import {
  LanguageLinks,
  ParsedLanguageLinks,
  Language,
  EntityOperation,
  ParsedEntityOperation,
  EntityOperations,
  ParsedEntityOperations,
  IntegerItem,
  FieldItemList,
  UuidItem,
  LanguageItem,
  EntityReferenceNodeTypeItem,
  ParsedEntityReferenceNodeTypeItem,
  TimestampItem,
  EntityReferenceUserItem,
  ParsedEntityReferenceUserItem,
  StringItem,
  BooleanItem,
  MetatagField,
  Metatags,
  PathItem,
  NodeBase,
  ParsedNodeBase,
  LinkItem,
  ParsedLinkItem,
  EntityReferenceMediaTypeItem,
  ParsedEntityReferenceMediaTypeItem,
  FileUriItem,
  FileBase,
  ParsedFileBase,
  Styles,
  ParsedStyles,
  FileImage,
  ParsedFileImage,
  File,
  FileOther,
  ParsedFileOther,
  ParsedFile,
  Entity,
  ImageFileWithTargetItem,
  ParsedImageFileWithTargetItem,
  MediaBase,
  ParsedMediaBase,
  FileFileWithTargetItem,
  ParsedFileFileWithTargetItem,
  MediaDocument,
  ParsedMediaDocument,
  Media,
  MediaImage,
  ParsedMediaImage,
  VideoEmbedFieldItem,
  ParsedVideoEmbedFieldItem,
  MediaVideo,
  ParsedMediaVideo,
  ParsedMedia,
  EntityReferenceMediaWithTargetNodeHomepageFieldIntroductionImageItem,
  ListStringItem,
  MetatagItem,
  EntityReferenceParagraphsTypeItem,
  ParsedEntityReferenceParagraphsTypeItem,
  ParagraphBase,
  ParsedParagraphBase,
  EntityReferenceMediaWithTargetParagraphCtaFieldImageItem,
  ParagraphCta,
  ParsedParagraphCta,
  Paragraph,
  ParagraphCustomSpacer,
  ParsedParagraphCustomSpacer,
  EntityReferenceMediaWithTargetParagraphDownloadListFieldDownloadItem,
  ParagraphDownloadList,
  ParsedParagraphDownloadList,
  EntityReferenceRevisionsParagraphWithTargetParagraphDownloadsFieldDownloadListItem,
  ParagraphDownloads,
  ParsedParagraphDownloads,
  TextItem,
  EntityReferenceMediaWithTargetParagraphExpandableContentBlockFieldDownloadsItem,
  ParagraphExpandableContentBlock,
  ParsedParagraphExpandableContentBlock,
  EntityReferenceRevisionsParagraphWithTargetParagraphExpandableContentBlocksFieldExpandableContentBlocksItem,
  ParagraphExpandableContentBlocks,
  ParsedParagraphExpandableContentBlocks,
  EntityReferenceRevisionsParagraphWithTargetParagraphFactsAndFiguresFieldFactsAndFiguresItemsItem,
  ParsedParagraphFactsAndFiguresItem,
  ParagraphFactsAndFiguresItem,
  ParagraphFactsAndFigures,
  ParsedParagraphFactsAndFigures,
  FloatItem,
  EntityReferenceMediaWithTargetParagraphFeaturedContentFieldImageItem,
  ParagraphFeaturedContent,
  ParsedParagraphFeaturedContent,
  FormListItem,
  ParagraphForm,
  ParsedParagraphForm,
  EntityReferenceMediaWithTargetParagraphGridBlockImageFieldImageItem,
  ParagraphGridBlockImage,
  ParsedParagraphGridBlockImage,
  ParagraphGridBlockPlain,
  ParsedParagraphGridBlockPlain,
  EntityReferenceRevisionsParagraphWithTargetParagraphGridBlocksImageFieldGridBlocksItem,
  ParagraphGridBlocksImage,
  ParsedParagraphGridBlocksImage,
  EntityReferenceRevisionsParagraphWithTargetParagraphGridBlocksPlainFieldGridBlocksItem,
  ParagraphGridBlocksPlain,
  ParsedParagraphGridBlocksPlain,
  EntityReferenceRevisionsParagraphWithTargetParagraphGridHighlightFieldHighlightItemsItem,
  ParsedParagraphGridItemHighlight,
  ParagraphGridItemHighlight,
  ParagraphGridHighlight,
  ParsedParagraphGridHighlight,
  ParagraphHubspotForm,
  ParsedParagraphHubspotForm,
  ParagraphIframe,
  ParsedParagraphIframe,
  EntityReferenceMediaWithTargetParagraphImageFieldImageItem,
  ParagraphImage,
  ParsedParagraphImage,
  EntityReferenceRevisionsParagraphWithTargetParagraphImageGalleryFieldImageGalleryItem,
  ParagraphImageGallery,
  ParsedParagraphImageGallery,
  EntityReferenceMediaWithTargetParagraphLatestUpdateItemFieldImageItem,
  ParagraphLatestUpdateItem,
  ParsedParagraphLatestUpdateItem,
  EntityReferenceRevisionsParagraphWithTargetParagraphLatestUpdatesBlockFieldLatestUpdateItemItem,
  ParagraphLatestUpdatesBlock,
  ParsedParagraphLatestUpdatesBlock,
  ParagraphLinkListItem,
  ParsedParagraphLinkListItem,
  EntityReferenceRevisionsParagraphWithTargetParagraphLinksListFieldLinksListItem,
  ParagraphLinksList,
  ParsedParagraphLinksList,
  EntityReferenceMediaWithTargetParagraphMediaFieldMediaItem,
  ParagraphMedia,
  ParsedParagraphMedia,
  EntityReferenceMediaWithTargetParagraphMediaItemFieldMediaItem,
  ParagraphMediaItem,
  ParsedParagraphMediaItem,
  EntityReferenceMediaWithTargetParagraphMediaItemNestedFieldMediaItem,
  ParagraphMediaItemNested,
  ParsedParagraphMediaItemNested,
  EntityReferenceRevisionsParagraphWithTargetParagraphMediaNestedFieldMediaItemItem,
  ParagraphMediaNested,
  ParsedParagraphMediaNested,
  ParagraphPressReleases,
  ParsedParagraphPressReleases,
  ParagraphQuote,
  ParsedParagraphQuote,
  EntityReferenceMediaWithTargetParagraphQuoteItemFieldImageItem,
  ParagraphQuoteItem,
  ParsedParagraphQuoteItem,
  ParagraphQuoteNested,
  ParsedParagraphQuoteNested,
  EntityReferenceRevisionsParagraphWithTargetParagraphQuotesFieldQuoteItemsItem,
  ParagraphQuotes,
  ParsedParagraphQuotes,
  EntityReferenceRevisionsParagraphWithTargetParagraphReportsOverviewFieldTabsItem,
  ParsedParagraphReportsTab,
  ParagraphReportsTab,
  ParagraphReportsOverview,
  ParsedParagraphReportsOverview,
  EntityReferenceRevisionsParagraphWithTargetParagraphReportsTabFieldRowsItem,
  ParsedParagraphReportsTableRow,
  ParagraphReportsTableRow,
  EntityReferenceMediaWithTargetParagraphReportsTableRowFieldCalendarFileItem,
  DatetimeItem,
  EntityReferenceMediaWithTargetParagraphReportsTableRowFieldPresentationFileItem,
  EntityReferenceMediaWithTargetParagraphReportsTableRowFieldReportFileItem,
  ParagraphStoriesGrid,
  ParsedParagraphStoriesGrid,
  ParagraphText,
  ParsedParagraphText,
  ParagraphTextNested,
  ParsedParagraphTextNested,
  EntityReferenceMediaWithTargetParagraphTextWithImageFieldImageItem,
  ParagraphTextWithImage,
  ParsedParagraphTextWithImage,
  EntityReferenceRevisionsParagraphWithTargetParagraphTextWithReadMoreFieldReadMoreItem,
  ParagraphTextWithReadMore,
  ParsedParagraphTextWithReadMore,
  EntityReferenceRevisionsParagraphWithTargetParagraphTimelineFieldItemsItem,
  ParsedParagraphTimelineItem,
  ParagraphTimelineItem,
  ParagraphTimeline,
  ParsedParagraphTimeline,
  EntityReferenceMediaWithTargetParagraphTimelineItemFieldMediaItem,
  EntityReferenceMediaWithTargetParagraphTimelineItemFieldTimelineBackgroundImageItem,
  ParsedParagraph,
  EntityReferenceRevisionsParagraphWithTargetNodeHomepageFieldPageContentItem,
  JsonNativeBinaryItem,
  NodeHomepage,
  ParsedNodeHomepage,
  Node,
  EntityReferenceMediaWithTargetNodeLandingPageFieldIntroductionImageItem,
  EntityReferenceRevisionsParagraphWithTargetNodeLandingPageFieldPageContentItem,
  NodeLandingPage,
  ParsedNodeLandingPage,
  EntityReferenceMediaWithTargetNodePageFieldIntroductionImageItem,
  EntityReferenceRevisionsParagraphWithTargetNodePageFieldPageContentItem,
  NodePage,
  ParsedNodePage,
  EntityReferenceMediaWithTargetNodeStoryFieldIntroductionImageItem,
  EntityReferenceRevisionsParagraphWithTargetNodeStoryFieldPageContentItem,
  NodeStory,
  ParsedNodeStory,
  ParsedNode,
  EntityReferenceTaxonomyVocabularyItem,
  ParsedEntityReferenceTaxonomyVocabularyItem,
  EntityReferenceTaxonomyTermWithTargetItem,
  ParsedTaxonomyTerm,
  TaxonomyTermBase,
  ParsedTaxonomyTermBase,
  TaxonomyTermPageType,
  ParsedTaxonomyTermPageType,
  TaxonomyTerm,
  InputEntity,
  ParsedInputEntity,
  ParsedEntity
} from './types'
import {
  Map,
  OrderedMap,
  List
} from 'immutable'
import * as Moment from 'moment'

export const noop_parser = <T>(t: T): T => t

export const language_links_parser = (l: LanguageLinks): ParsedLanguageLinks => Map<Language, string>(l)

export const entity_operation_parser = (t: EntityOperation): ParsedEntityOperation => ({
  title: t.title,
  url: t.url
})

export const entity_operations_parser = (l: EntityOperations | undefined): ParsedEntityOperations => l ? OrderedMap<string, EntityOperation>(l).sortBy(o => (o as EntityOperation).weight).map(o => entity_operation_parser(o as EntityOperation)).toOrderedMap() : OrderedMap<string, EntityOperation>()

export const integer_item_parser = (t: IntegerItem): number => noop_parser<number>(t.value)

export const singular_optional_integer_parser = (f: FieldItemList<IntegerItem>): number | null => f && f.length > 0 ? integer_item_parser(f[0]) : null

export const uuid_item_parser = (t: UuidItem): string => noop_parser<string>(t.value)

export const singular_optional_uuid_parser = (f: FieldItemList<UuidItem>): string | null => f && f.length > 0 ? uuid_item_parser(f[0]) : null

export const language_item_parser = (t: LanguageItem): Language => t.value

export const singular_optional_language_parser = (f: FieldItemList<LanguageItem>): Language | null => f && f.length > 0 ? language_item_parser(f[0]) : null

export const entity_reference_node_type_item_parser = (t: EntityReferenceNodeTypeItem): ParsedEntityReferenceNodeTypeItem => ({
  target_id: noop_parser<string>(t.target_id),
  label: t.target_label
})

export const singular_required_entity_reference_node_type_parser = (f: FieldItemList<EntityReferenceNodeTypeItem>): ParsedEntityReferenceNodeTypeItem => entity_reference_node_type_item_parser(f[0])

export const node_bundle_parser = (f: FieldItemList<EntityReferenceNodeTypeItem>): string => f[0].target_id

export const moment_parser = (t: string): Moment.Moment => Moment.utc(t).local()

export const required_date_time_parser = (t: string): Moment.Moment => moment_parser(t)

export const timestamp_item_parser = (t: TimestampItem): Moment.Moment => required_date_time_parser(t.value)

export const singular_optional_created_parser = (f: FieldItemList<TimestampItem>): Moment.Moment | null => f && f.length > 0 ? timestamp_item_parser(f[0]) : null

export const entity_reference_user_item_parser = (t: EntityReferenceUserItem): ParsedEntityReferenceUserItem => ({
  id: noop_parser<number>(t.target_id),
  url: t.url,
  label: t.target_label
})

export const singular_optional_entity_reference_user_parser = (f: FieldItemList<EntityReferenceUserItem>): ParsedEntityReferenceUserItem | null => f && f.length > 0 ? entity_reference_user_item_parser(f[0]) : null

export const string_item_parser = (t: StringItem): string => noop_parser<string>(t.value)

export const singular_optional_string_long_parser = (f: FieldItemList<StringItem>): string | null => f && f.length > 0 ? string_item_parser(f[0]) : null

export const boolean_item_parser = (t: BooleanItem): boolean => noop_parser<boolean>(t.value)

export const singular_optional_boolean_parser = (f: FieldItemList<BooleanItem>): boolean | null => f && f.length > 0 ? boolean_item_parser(f[0]) : null

export const singular_required_string_parser = (f: FieldItemList<StringItem>): string => string_item_parser(f[0])

export const singular_optional_changed_parser = (f: FieldItemList<TimestampItem>): Moment.Moment | null => f && f.length > 0 ? timestamp_item_parser(f[0]) : null

export const singular_optional_string_parser = (f: FieldItemList<StringItem>): string | null => f && f.length > 0 ? string_item_parser(f[0]) : null

export const metatag_field_parser = (t: MetatagField): Metatags => t ? (t.value) : {}

export const path_item_parser = (t: PathItem): string | null => noop_parser<string | null>(t.alias)

export const singular_optional_path_parser = (f: FieldItemList<PathItem> | undefined): string | null => f && f.length > 0 ? path_item_parser(f[0]) : null

export const node_base_parser = (t: NodeBase): ParsedNodeBase => ({
  entity_type: ((_: any): "node" => "node")(t),
  id: singular_optional_integer_parser(t.nid),
  status: singular_optional_boolean_parser(t.status),
  author: singular_optional_entity_reference_user_parser(t.uid),
  language: singular_optional_language_parser(t.langcode),
  label: singular_required_string_parser(t.title),
  revision_timestamp: singular_optional_created_parser(t.revision_timestamp),
  revision_uid: singular_optional_entity_reference_user_parser(t.revision_uid),
  revision_log: singular_optional_string_long_parser(t.revision_log),
  created: singular_optional_created_parser(t.created),
  changed: singular_optional_changed_parser(t.changed),
  promote: singular_optional_boolean_parser(t.promote),
  sticky: singular_optional_boolean_parser(t.sticky),
  default_langcode: singular_optional_boolean_parser(t.default_langcode),
  revision_translation_affected: singular_optional_boolean_parser(t.revision_translation_affected),
  moderation_state: singular_optional_string_parser(t.moderation_state),
  metatag: metatag_field_parser(t.metatag),
  path: singular_optional_path_parser(t.path),
  content_translation_source: singular_optional_language_parser(t.content_translation_source),
  content_translation_outdated: singular_optional_boolean_parser(t.content_translation_outdated),
  language_links: language_links_parser(t.language_links),
  entity_operations: entity_operations_parser(t.entity_operations)
})

export const link_item_parser = (t: LinkItem): ParsedLinkItem => ({
  title: noop_parser<string | null>(t.title),
  url: t.processed_url
})

export const singular_optional_link_parser = (f: FieldItemList<LinkItem>): ParsedLinkItem | null => f && f.length > 0 ? link_item_parser(f[0]) : null

export const entity_reference_media_type_item_parser = (t: EntityReferenceMediaTypeItem): ParsedEntityReferenceMediaTypeItem => ({
  target_id: noop_parser<string>(t.target_id),
  label: t.target_label
})

export const singular_required_entity_reference_media_type_parser = (f: FieldItemList<EntityReferenceMediaTypeItem>): ParsedEntityReferenceMediaTypeItem => entity_reference_media_type_item_parser(f[0])

export const media_bundle_parser = (f: FieldItemList<EntityReferenceMediaTypeItem>): string => f[0].target_id

export const file_uri_item_parser = (t: FileUriItem): string | null => noop_parser<string | null>(t.url)

export const singular_optional_file_uri_parser = (f: FieldItemList<FileUriItem>): string | null => f && f.length > 0 ? file_uri_item_parser(f[0]) : null

export const file_base_parser = (t: FileBase): ParsedFileBase => ({
  entity_type: ((_: any): "file" => "file")(t),
  id: singular_optional_integer_parser(t.fid),
  label: singular_optional_string_parser(t.filename),
  url: singular_optional_file_uri_parser(t.uri)
})

export const styles_parser = (t: Styles): ParsedStyles => ({
  "1200x1200": t["1200x1200"],
  "1225w": t["1225w"],
  "1280w": t["1280w"],
  "1280x720": t["1280x720"],
  "1400w": t["1400w"],
  "1920w": t["1920w"],
  "2800w": t["2800w"],
  "2880w": t["2880w"],
  "360x360": t["360x360"],
  "425w": t["425w"],
  "450x450": t["450x450"],
  "600x600": t["600x600"],
  "640w": t["640w"],
  "640x360": t["640x360"],
  "700w": t["700w"],
  "720x720": t["720x720"],
  "850w": t["850w"],
  crop_thumbnail: t.crop_thumbnail,
  grid: t.grid,
  large: t.large,
  media: t.media,
  medium: t.medium,
  text_with_image: t.text_with_image,
  thumbnail: t.thumbnail
})

export const file_image_parser = (t: FileImage): ParsedFileImage => ({
  ...file_base_parser(t),
  style_urls: (t.style_urls !== undefined ? styles_parser(t.style_urls) : undefined)
})

export const file_image_guard = (t:File): t is FileImage => (t as any).style_urls !== undefined

export const file_other_parser = (t: FileOther): ParsedFileOther => ({
  ...file_base_parser(t)
})

export const file_other_guard = (t:File): t is FileOther => (t as any).style_urls === undefined

export const file_parser = (t: File): ParsedFile => file_image_guard(t) ? file_image_parser(t) : file_other_parser(t)

export const file_guard = (t: Entity): t is File => (
  (t as any).fid !== undefined &&
  (t as any).uuid !== undefined &&
  (t as any).langcode !== undefined &&
  (t as any).uid !== undefined &&
  (t as any).filename !== undefined &&
  (t as any).uri !== undefined &&
  (t as any).filemime !== undefined &&
  (t as any).filesize !== undefined &&
  (t as any).status !== undefined &&
  (t as any).created !== undefined &&
  (t as any).changed !== undefined
)

export const image_file_with_target_item_parser = (t: ImageFileWithTargetItem): ParsedImageFileWithTargetItem => ({
  alt: noop_parser<string | null>(t.alt),
  image: (t.target !== undefined ? file_image_parser(t.target) : undefined)
})

export const image_file_with_target_item_guard = (t: any): t is ImageFileWithTargetItem => (t.target_id !== undefined) && (t.alt !== undefined) && (t.title !== undefined) && (t.width !== undefined) && (t.height !== undefined) && ((t.target === undefined) || file_image_guard(t.target))

export const singular_optional_image_file_with_target_parser = (f: FieldItemList<ImageFileWithTargetItem>): ParsedImageFileWithTargetItem | null => f && f.length > 0 && image_file_with_target_item_guard(f[0]) ? image_file_with_target_item_parser(f[0]) : null

export const media_base_parser = (t: MediaBase): ParsedMediaBase => ({
  entity_type: ((_: any): "media" => "media")(t),
  id: singular_optional_integer_parser(t.mid),
  language: singular_optional_language_parser(t.langcode),
  label: singular_required_string_parser(t.name),
  revision_created: singular_optional_created_parser(t.revision_created),
  revision_user: singular_optional_entity_reference_user_parser(t.revision_user),
  revision_log_message: singular_optional_string_long_parser(t.revision_log_message),
  status: singular_optional_boolean_parser(t.status),
  uid: singular_optional_entity_reference_user_parser(t.uid),
  thumbnail: singular_optional_image_file_with_target_parser(t.thumbnail),
  created: singular_optional_created_parser(t.created),
  changed: singular_optional_changed_parser(t.changed),
  default_langcode: singular_optional_boolean_parser(t.default_langcode),
  revision_translation_affected: singular_optional_boolean_parser(t.revision_translation_affected),
  metatag: metatag_field_parser(t.metatag),
  path: singular_optional_path_parser(t.path),
  language_links: language_links_parser(t.language_links),
  entity_operations: entity_operations_parser(t.entity_operations)
})

export const file_file_with_target_item_parser = (t: FileFileWithTargetItem): ParsedFileFileWithTargetItem => ({
  description: noop_parser<string | null>(t.description),
  file: (t.target !== undefined ? file_other_parser(t.target) : undefined)
})

export const file_file_with_target_item_guard = (t: any): t is FileFileWithTargetItem => (t.target_id !== undefined) && (t.display !== undefined) && (t.description !== undefined) && ((t.target === undefined) || file_other_guard(t.target))

export const singular_required_file_file_with_target_parser = (f: FieldItemList<FileFileWithTargetItem>): ParsedFileFileWithTargetItem => file_file_with_target_item_parser(f[0])

export const media_document_parser = (t: MediaDocument): ParsedMediaDocument => ({
  ...media_base_parser(t),
  bundle: ((_: any): "document" => "document")(t.bundle),
  field_media_file: singular_required_file_file_with_target_parser(t.field_media_file)
})

export const media_document_guard = (t: Media): t is MediaDocument => media_bundle_parser(t.bundle) == "document"

export const singular_required_image_file_with_target_parser = (f: FieldItemList<ImageFileWithTargetItem>): ParsedImageFileWithTargetItem => image_file_with_target_item_parser(f[0])

export const media_image_parser = (t: MediaImage): ParsedMediaImage => ({
  ...media_base_parser(t),
  bundle: ((_: any): "image" => "image")(t.bundle),
  field_media_image: singular_required_image_file_with_target_parser(t.field_media_image),
  field_source: singular_optional_string_parser(t.field_source)
})

export const media_image_guard = (t: Media): t is MediaImage => media_bundle_parser(t.bundle) == "image"

export const video_embed_field_item_parser = (t: VideoEmbedFieldItem): ParsedVideoEmbedFieldItem => ({
  type: t.video_type,
  id: t.video_id,
  iframe_url: t.iframe_url
})

export const singular_required_video_embed_field_parser = (f: FieldItemList<VideoEmbedFieldItem>): ParsedVideoEmbedFieldItem => video_embed_field_item_parser(f[0])

export const media_video_parser = (t: MediaVideo): ParsedMediaVideo => ({
  ...media_base_parser(t),
  bundle: ((_: any): "video" => "video")(t.bundle),
  field_media_video_embed_field: singular_required_video_embed_field_parser(t.field_media_video_embed_field),
  field_source: singular_optional_string_parser(t.field_source)
})

export const media_video_guard = (t: Media): t is MediaVideo => media_bundle_parser(t.bundle) == "video"

export const media_parser = (t: Media): ParsedMedia =>
  media_document_guard(t) ?
    media_document_parser(t) :
  media_image_guard(t) ?
    media_image_parser(t) :
    media_video_parser(t)

export const media_guard = (t: Entity): t is Media => (
  (t as any).mid !== undefined &&
  (t as any).uuid !== undefined &&
  (t as any).vid !== undefined &&
  (t as any).langcode !== undefined &&
  (t as any).bundle !== undefined &&
  (t as any).bundle[0].target_type == "media_type" &&
  (t as any).revision_created !== undefined &&
  (t as any).revision_user !== undefined &&
  (t as any).revision_log_message !== undefined &&
  (t as any).status !== undefined &&
  (t as any).uid !== undefined &&
  (t as any).name !== undefined &&
  (t as any).thumbnail !== undefined &&
  (t as any).created !== undefined &&
  (t as any).changed !== undefined &&
  (t as any).default_langcode !== undefined &&
  (t as any).revision_translation_affected !== undefined &&
  (t as any).metatag !== undefined
)

export const entity_reference_media_with_target_node_homepage_field_introduction_image_item_parser = (t: EntityReferenceMediaWithTargetNodeHomepageFieldIntroductionImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_homepage_field_introduction_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeHomepageFieldIntroductionImageItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_node_homepage_field_introduction_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeHomepageFieldIntroductionImageItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_node_homepage_field_introduction_image_item_parser(f[0])

export const list_string_item_parser = (t: ListStringItem): string => noop_parser<string>(t.value)

export const singular_required_list_string_parser = (f: FieldItemList<ListStringItem>): string => list_string_item_parser(f[0])

export const singular_optional_video_embed_field_parser = (f: FieldItemList<VideoEmbedFieldItem>): ParsedVideoEmbedFieldItem | null => f && f.length > 0 ? video_embed_field_item_parser(f[0]) : null

export const metatag_item_parser = (t: MetatagItem): Metatags => t.value

export const singular_optional_metatag_parser = (f: FieldItemList<MetatagItem>): Metatags | null => f && f.length > 0 ? metatag_item_parser(f[0]) : null

export const entity_reference_paragraphs_type_item_parser = (t: EntityReferenceParagraphsTypeItem): ParsedEntityReferenceParagraphsTypeItem => ({
  target_id: noop_parser<string>(t.target_id),
  label: t.target_label
})

export const singular_required_entity_reference_paragraphs_type_parser = (f: FieldItemList<EntityReferenceParagraphsTypeItem>): ParsedEntityReferenceParagraphsTypeItem => entity_reference_paragraphs_type_item_parser(f[0])

export const paragraph_bundle_parser = (f: FieldItemList<EntityReferenceParagraphsTypeItem>): string => f[0].target_id

export const paragraph_base_parser = (t: ParagraphBase): ParsedParagraphBase => ({
  entity_type: ((_: any): "paragraph" => "paragraph")(t),
  id: singular_optional_integer_parser(t.id),
  language: singular_optional_language_parser(t.langcode),
  status: singular_optional_boolean_parser(t.status),
  created: singular_optional_created_parser(t.created),
  parent_id: singular_optional_string_parser(t.parent_id),
  parent_type: singular_optional_string_parser(t.parent_type),
  parent_field_name: singular_optional_string_parser(t.parent_field_name),
  behavior_settings: singular_optional_string_long_parser(t.behavior_settings),
  default_langcode: singular_optional_boolean_parser(t.default_langcode),
  revision_translation_affected: singular_optional_boolean_parser(t.revision_translation_affected),
  language_links: language_links_parser(t.language_links),
  entity_operations: entity_operations_parser(t.entity_operations)
})

export const entity_reference_media_with_target_paragraph_cta_field_image_item_parser = (t: EntityReferenceMediaWithTargetParagraphCtaFieldImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_cta_field_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphCtaFieldImageItem => (t.target_id !== undefined)

export const singular_optional_entity_reference_media_with_target_paragraph_cta_field_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphCtaFieldImageItem>): ParsedMediaImage | undefined | null => f && f.length > 0 && entity_reference_media_with_target_paragraph_cta_field_image_item_guard(f[0]) ? entity_reference_media_with_target_paragraph_cta_field_image_item_parser(f[0]) : null

export const singular_required_string_long_parser = (f: FieldItemList<StringItem>): string => string_item_parser(f[0])

export const paragraph_cta_parser = (t: ParagraphCta): ParsedParagraphCta => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "cta" => "cta")(t.type),
  field_image: singular_optional_entity_reference_media_with_target_paragraph_cta_field_image_parser(t.field_image),
  field_introduction: singular_required_string_long_parser(t.field_introduction),
  field_link: singular_optional_link_parser(t.field_link),
  field_title: singular_required_string_parser(t.field_title)
})

export const paragraph_cta_guard = (t: Paragraph): t is ParagraphCta => paragraph_bundle_parser(t.type) == "cta"

export const paragraph_custom_spacer_parser = (t: ParagraphCustomSpacer): ParsedParagraphCustomSpacer => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "custom_spacer" => "custom_spacer")(t.type)
})

export const paragraph_custom_spacer_guard = (t: Paragraph): t is ParagraphCustomSpacer => paragraph_bundle_parser(t.type) == "custom_spacer"

export const entity_reference_media_with_target_paragraph_download_list_field_download_item_parser = (t: EntityReferenceMediaWithTargetParagraphDownloadListFieldDownloadItem): ParsedMediaDocument | undefined | undefined => (t.target !== undefined ? ((t: MediaDocument): ParsedMediaDocument =>
    media_document_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_download_list_field_download_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphDownloadListFieldDownloadItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph_download_list_field_download_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphDownloadListFieldDownloadItem>): ParsedMediaDocument | undefined => entity_reference_media_with_target_paragraph_download_list_field_download_item_parser(f[0])

export const paragraph_download_list_parser = (t: ParagraphDownloadList): ParsedParagraphDownloadList => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "download_list" => "download_list")(t.type),
  field_download: singular_required_entity_reference_media_with_target_paragraph_download_list_field_download_parser(t.field_download),
  field_title: singular_required_string_parser(t.field_title)
})

export const paragraph_download_list_guard = (t: Paragraph): t is ParagraphDownloadList => paragraph_bundle_parser(t.type) == "download_list"

export const entity_reference_revisions_paragraph_with_target_paragraph_downloads_field_download_list_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphDownloadsFieldDownloadListItem): ParsedParagraphDownloadList | undefined | undefined => (t.target !== undefined ? ((t: ParagraphDownloadList): ParsedParagraphDownloadList =>
    paragraph_download_list_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_downloads_field_download_list_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphDownloadsFieldDownloadListItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_downloads_field_download_list_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphDownloadsFieldDownloadListItem>): List<ParsedParagraphDownloadList> =>
    List<ParsedParagraphDownloadList>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_downloads_field_download_list_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_downloads_field_download_list_item_parser(i)).filter(i => i !== undefined))

export const paragraph_downloads_parser = (t: ParagraphDownloads): ParsedParagraphDownloads => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "downloads" => "downloads")(t.type),
  field_download_list: plural_entity_reference_revisions_paragraph_with_target_paragraph_downloads_field_download_list_parser(t.field_download_list),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_downloads_guard = (t: Paragraph): t is ParagraphDownloads => paragraph_bundle_parser(t.type) == "downloads"

export const text_item_parser = (t: TextItem): string => t.processed

export const singular_optional_text_long_parser = (f: FieldItemList<TextItem>): string | null => f && f.length > 0 ? text_item_parser(f[0]) : null

export const entity_reference_media_with_target_paragraph_expandable_content_block_field_downloads_item_parser = (t: EntityReferenceMediaWithTargetParagraphExpandableContentBlockFieldDownloadsItem): ParsedMediaDocument | undefined | undefined => (t.target !== undefined ? ((t: MediaDocument): ParsedMediaDocument =>
    media_document_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_expandable_content_block_field_downloads_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphExpandableContentBlockFieldDownloadsItem => (t.target_id !== undefined)

export const plural_entity_reference_media_with_target_paragraph_expandable_content_block_field_downloads_parser =
  (f: FieldItemList<EntityReferenceMediaWithTargetParagraphExpandableContentBlockFieldDownloadsItem>): List<ParsedMediaDocument> =>
    List<ParsedMediaDocument>(f.filter(i => entity_reference_media_with_target_paragraph_expandable_content_block_field_downloads_item_guard(i)).map(i => entity_reference_media_with_target_paragraph_expandable_content_block_field_downloads_item_parser(i)).filter(i => i !== undefined))

export const plural_link_parser =
  (f: FieldItemList<LinkItem>): List<ParsedLinkItem> =>
    List<ParsedLinkItem>(f.map(i => link_item_parser(i)))

export const paragraph_expandable_content_block_parser = (t: ParagraphExpandableContentBlock): ParsedParagraphExpandableContentBlock => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "expandable_content_block" => "expandable_content_block")(t.type),
  field_body: singular_optional_text_long_parser(t.field_body),
  field_downloads: plural_entity_reference_media_with_target_paragraph_expandable_content_block_field_downloads_parser(t.field_downloads),
  field_link_list: plural_link_parser(t.field_link_list),
  field_title: singular_required_string_parser(t.field_title)
})

export const paragraph_expandable_content_block_guard = (t: Paragraph): t is ParagraphExpandableContentBlock => paragraph_bundle_parser(t.type) == "expandable_content_block"

export const entity_reference_revisions_paragraph_with_target_paragraph_expandable_content_blocks_field_expandable_content_blocks_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphExpandableContentBlocksFieldExpandableContentBlocksItem): ParsedParagraphExpandableContentBlock | undefined | undefined => (t.target !== undefined ? ((t: ParagraphExpandableContentBlock): ParsedParagraphExpandableContentBlock =>
    paragraph_expandable_content_block_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_expandable_content_blocks_field_expandable_content_blocks_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphExpandableContentBlocksFieldExpandableContentBlocksItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_expandable_content_blocks_field_expandable_content_blocks_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphExpandableContentBlocksFieldExpandableContentBlocksItem>): List<ParsedParagraphExpandableContentBlock> =>
    List<ParsedParagraphExpandableContentBlock>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_expandable_content_blocks_field_expandable_content_blocks_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_expandable_content_blocks_field_expandable_content_blocks_item_parser(i)).filter(i => i !== undefined))

export const paragraph_expandable_content_blocks_parser = (t: ParagraphExpandableContentBlocks): ParsedParagraphExpandableContentBlocks => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "expandable_content_blocks" => "expandable_content_blocks")(t.type),
  field_expandable_content_blocks: plural_entity_reference_revisions_paragraph_with_target_paragraph_expandable_content_blocks_field_expandable_content_blocks_parser(t.field_expandable_content_blocks),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_link: singular_optional_link_parser(t.field_link),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_expandable_content_blocks_guard = (t: Paragraph): t is ParagraphExpandableContentBlocks => paragraph_bundle_parser(t.type) == "expandable_content_blocks"

export const entity_reference_revisions_paragraph_with_target_paragraph_facts_and_figures_field_facts_and_figures_items_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphFactsAndFiguresFieldFactsAndFiguresItemsItem): ParsedParagraphFactsAndFiguresItem | undefined | undefined => (t.target !== undefined ? ((t: ParagraphFactsAndFiguresItem): ParsedParagraphFactsAndFiguresItem =>
    paragraph_facts_and_figures_item_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_facts_and_figures_field_facts_and_figures_items_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphFactsAndFiguresFieldFactsAndFiguresItemsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_facts_and_figures_field_facts_and_figures_items_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphFactsAndFiguresFieldFactsAndFiguresItemsItem>): List<ParsedParagraphFactsAndFiguresItem> =>
    List<ParsedParagraphFactsAndFiguresItem>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_facts_and_figures_field_facts_and_figures_items_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_facts_and_figures_field_facts_and_figures_items_item_parser(i)).filter(i => i !== undefined))

export const paragraph_facts_and_figures_parser = (t: ParagraphFactsAndFigures): ParsedParagraphFactsAndFigures => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "facts_and_figures" => "facts_and_figures")(t.type),
  field_facts_and_figures_items: plural_entity_reference_revisions_paragraph_with_target_paragraph_facts_and_figures_field_facts_and_figures_items_parser(t.field_facts_and_figures_items)
})

export const paragraph_facts_and_figures_guard = (t: Paragraph): t is ParagraphFactsAndFigures => paragraph_bundle_parser(t.type) == "facts_and_figures"

export const float_item_parser = (t: FloatItem): any => noop_parser<any>(t.value)

export const singular_required_float_parser = (f: FieldItemList<FloatItem>): any => float_item_parser(f[0])

export const paragraph_facts_and_figures_item_parser = (t: ParagraphFactsAndFiguresItem): ParsedParagraphFactsAndFiguresItem => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "facts_and_figures_item" => "facts_and_figures_item")(t.type),
  field_label: singular_required_string_parser(t.field_label),
  field_number: singular_required_float_parser(t.field_number)
})

export const paragraph_facts_and_figures_item_guard = (t: Paragraph): t is ParagraphFactsAndFiguresItem => paragraph_bundle_parser(t.type) == "facts_and_figures_item"

export const entity_reference_media_with_target_paragraph_featured_content_field_image_item_parser = (t: EntityReferenceMediaWithTargetParagraphFeaturedContentFieldImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_featured_content_field_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphFeaturedContentFieldImageItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph_featured_content_field_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphFeaturedContentFieldImageItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_paragraph_featured_content_field_image_item_parser(f[0])

export const singular_optional_list_string_parser = (f: FieldItemList<ListStringItem>): string | null => f && f.length > 0 ? list_string_item_parser(f[0]) : null

export const paragraph_featured_content_parser = (t: ParagraphFeaturedContent): ParsedParagraphFeaturedContent => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "featured_content" => "featured_content")(t.type),
  field_background_image: singular_required_list_string_parser(t.field_background_image),
  field_image: singular_required_entity_reference_media_with_target_paragraph_featured_content_field_image_parser(t.field_image),
  field_image_position: singular_optional_list_string_parser(t.field_image_position),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_label: singular_required_string_parser(t.field_label),
  field_link: singular_optional_link_parser(t.field_link),
  field_title: singular_required_string_parser(t.field_title)
})

export const paragraph_featured_content_guard = (t: Paragraph): t is ParagraphFeaturedContent => paragraph_bundle_parser(t.type) == "featured_content"

export const form_list_item_parser = (t: FormListItem): string | null => noop_parser<string | null>(t.value)

export const singular_required_form_list_parser = (f: FieldItemList<FormListItem>): string | null => form_list_item_parser(f[0])

export const paragraph_form_parser = (t: ParagraphForm): ParsedParagraphForm => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "form" => "form")(t.type),
  field_form_list: singular_required_form_list_parser(t.field_form_list),
  field_form_type: singular_required_list_string_parser(t.field_form_type),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_form_guard = (t: Paragraph): t is ParagraphForm => paragraph_bundle_parser(t.type) == "form"

export const entity_reference_media_with_target_paragraph_grid_block_image_field_image_item_parser = (t: EntityReferenceMediaWithTargetParagraphGridBlockImageFieldImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_grid_block_image_field_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphGridBlockImageFieldImageItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph_grid_block_image_field_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphGridBlockImageFieldImageItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_paragraph_grid_block_image_field_image_item_parser(f[0])

export const paragraph_grid_block_image_parser = (t: ParagraphGridBlockImage): ParsedParagraphGridBlockImage => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "grid_block_image" => "grid_block_image")(t.type),
  field_image: singular_required_entity_reference_media_with_target_paragraph_grid_block_image_field_image_parser(t.field_image),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_link: singular_optional_link_parser(t.field_link),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_grid_block_image_guard = (t: Paragraph): t is ParagraphGridBlockImage => paragraph_bundle_parser(t.type) == "grid_block_image"

export const paragraph_grid_block_plain_parser = (t: ParagraphGridBlockPlain): ParsedParagraphGridBlockPlain => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "grid_block_plain" => "grid_block_plain")(t.type),
  field_introduction: singular_required_string_long_parser(t.field_introduction),
  field_label: singular_optional_string_parser(t.field_label),
  field_link: singular_optional_link_parser(t.field_link),
  field_title: singular_required_string_parser(t.field_title)
})

export const paragraph_grid_block_plain_guard = (t: Paragraph): t is ParagraphGridBlockPlain => paragraph_bundle_parser(t.type) == "grid_block_plain"

export const entity_reference_revisions_paragraph_with_target_paragraph_grid_blocks_image_field_grid_blocks_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphGridBlocksImageFieldGridBlocksItem): ParsedParagraphGridBlockImage | undefined | undefined => (t.target !== undefined ? ((t: ParagraphGridBlockImage): ParsedParagraphGridBlockImage =>
    paragraph_grid_block_image_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_grid_blocks_image_field_grid_blocks_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphGridBlocksImageFieldGridBlocksItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_grid_blocks_image_field_grid_blocks_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphGridBlocksImageFieldGridBlocksItem>): List<ParsedParagraphGridBlockImage> =>
    List<ParsedParagraphGridBlockImage>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_grid_blocks_image_field_grid_blocks_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_grid_blocks_image_field_grid_blocks_item_parser(i)).filter(i => i !== undefined))

export const paragraph_grid_blocks_image_parser = (t: ParagraphGridBlocksImage): ParsedParagraphGridBlocksImage => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "grid_blocks_image" => "grid_blocks_image")(t.type),
  field_grid_blocks: plural_entity_reference_revisions_paragraph_with_target_paragraph_grid_blocks_image_field_grid_blocks_parser(t.field_grid_blocks),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_link: singular_optional_link_parser(t.field_link),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_grid_blocks_image_guard = (t: Paragraph): t is ParagraphGridBlocksImage => paragraph_bundle_parser(t.type) == "grid_blocks_image"

export const entity_reference_revisions_paragraph_with_target_paragraph_grid_blocks_plain_field_grid_blocks_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphGridBlocksPlainFieldGridBlocksItem): ParsedParagraphGridBlockPlain | undefined | undefined => (t.target !== undefined ? ((t: ParagraphGridBlockPlain): ParsedParagraphGridBlockPlain =>
    paragraph_grid_block_plain_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_grid_blocks_plain_field_grid_blocks_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphGridBlocksPlainFieldGridBlocksItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_grid_blocks_plain_field_grid_blocks_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphGridBlocksPlainFieldGridBlocksItem>): List<ParsedParagraphGridBlockPlain> =>
    List<ParsedParagraphGridBlockPlain>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_grid_blocks_plain_field_grid_blocks_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_grid_blocks_plain_field_grid_blocks_item_parser(i)).filter(i => i !== undefined))

export const paragraph_grid_blocks_plain_parser = (t: ParagraphGridBlocksPlain): ParsedParagraphGridBlocksPlain => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "grid_blocks_plain" => "grid_blocks_plain")(t.type),
  field_grid_blocks: plural_entity_reference_revisions_paragraph_with_target_paragraph_grid_blocks_plain_field_grid_blocks_parser(t.field_grid_blocks),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_link: singular_optional_link_parser(t.field_link),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_grid_blocks_plain_guard = (t: Paragraph): t is ParagraphGridBlocksPlain => paragraph_bundle_parser(t.type) == "grid_blocks_plain"

export const entity_reference_revisions_paragraph_with_target_paragraph_grid_highlight_field_highlight_items_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphGridHighlightFieldHighlightItemsItem): ParsedParagraphGridItemHighlight | undefined | undefined => (t.target !== undefined ? ((t: ParagraphGridItemHighlight): ParsedParagraphGridItemHighlight =>
    paragraph_grid_item_highlight_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_grid_highlight_field_highlight_items_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphGridHighlightFieldHighlightItemsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_grid_highlight_field_highlight_items_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphGridHighlightFieldHighlightItemsItem>): List<ParsedParagraphGridItemHighlight> =>
    List<ParsedParagraphGridItemHighlight>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_grid_highlight_field_highlight_items_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_grid_highlight_field_highlight_items_item_parser(i)).filter(i => i !== undefined))

export const paragraph_grid_highlight_parser = (t: ParagraphGridHighlight): ParsedParagraphGridHighlight => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "grid_highlight" => "grid_highlight")(t.type),
  field_highlight_items: plural_entity_reference_revisions_paragraph_with_target_paragraph_grid_highlight_field_highlight_items_parser(t.field_highlight_items),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_grid_highlight_guard = (t: Paragraph): t is ParagraphGridHighlight => paragraph_bundle_parser(t.type) == "grid_highlight"

export const paragraph_grid_item_highlight_parser = (t: ParagraphGridItemHighlight): ParsedParagraphGridItemHighlight => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "grid_item_highlight" => "grid_item_highlight")(t.type),
  field_introduction: singular_required_string_long_parser(t.field_introduction),
  field_link: singular_optional_link_parser(t.field_link),
  field_title: singular_required_string_parser(t.field_title)
})

export const paragraph_grid_item_highlight_guard = (t: Paragraph): t is ParagraphGridItemHighlight => paragraph_bundle_parser(t.type) == "grid_item_highlight"

export const paragraph_hubspot_form_parser = (t: ParagraphHubspotForm): ParsedParagraphHubspotForm => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "hubspot_form" => "hubspot_form")(t.type),
  field_form_id: singular_required_string_parser(t.field_form_id),
  field_portal_id: singular_required_string_parser(t.field_portal_id)
})

export const paragraph_hubspot_form_guard = (t: Paragraph): t is ParagraphHubspotForm => paragraph_bundle_parser(t.type) == "hubspot_form"

export const singular_required_link_parser = (f: FieldItemList<LinkItem>): ParsedLinkItem => link_item_parser(f[0])

export const paragraph_iframe_parser = (t: ParagraphIframe): ParsedParagraphIframe => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "iframe" => "iframe")(t.type),
  field_link: singular_required_link_parser(t.field_link)
})

export const paragraph_iframe_guard = (t: Paragraph): t is ParagraphIframe => paragraph_bundle_parser(t.type) == "iframe"

export const entity_reference_media_with_target_paragraph_image_field_image_item_parser = (t: EntityReferenceMediaWithTargetParagraphImageFieldImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_image_field_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphImageFieldImageItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph_image_field_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphImageFieldImageItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_paragraph_image_field_image_item_parser(f[0])

export const paragraph_image_parser = (t: ParagraphImage): ParsedParagraphImage => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "image" => "image")(t.type),
  field_image: singular_required_entity_reference_media_with_target_paragraph_image_field_image_parser(t.field_image),
  field_image_caption: singular_optional_string_long_parser(t.field_image_caption)
})

export const paragraph_image_guard = (t: Paragraph): t is ParagraphImage => paragraph_bundle_parser(t.type) == "image"

export const entity_reference_revisions_paragraph_with_target_paragraph_image_gallery_field_image_gallery_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphImageGalleryFieldImageGalleryItem): ParsedParagraphImage | undefined | undefined => (t.target !== undefined ? ((t: ParagraphImage): ParsedParagraphImage =>
    paragraph_image_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_image_gallery_field_image_gallery_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphImageGalleryFieldImageGalleryItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_image_gallery_field_image_gallery_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphImageGalleryFieldImageGalleryItem>): List<ParsedParagraphImage> =>
    List<ParsedParagraphImage>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_image_gallery_field_image_gallery_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_image_gallery_field_image_gallery_item_parser(i)).filter(i => i !== undefined))

export const paragraph_image_gallery_parser = (t: ParagraphImageGallery): ParsedParagraphImageGallery => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "image_gallery" => "image_gallery")(t.type),
  field_image_gallery: plural_entity_reference_revisions_paragraph_with_target_paragraph_image_gallery_field_image_gallery_parser(t.field_image_gallery),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_image_gallery_guard = (t: Paragraph): t is ParagraphImageGallery => paragraph_bundle_parser(t.type) == "image_gallery"

export const entity_reference_media_with_target_paragraph_latest_update_item_field_image_item_parser = (t: EntityReferenceMediaWithTargetParagraphLatestUpdateItemFieldImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_latest_update_item_field_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphLatestUpdateItemFieldImageItem => (t.target_id !== undefined)

export const singular_optional_entity_reference_media_with_target_paragraph_latest_update_item_field_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphLatestUpdateItemFieldImageItem>): ParsedMediaImage | undefined | null => f && f.length > 0 && entity_reference_media_with_target_paragraph_latest_update_item_field_image_item_guard(f[0]) ? entity_reference_media_with_target_paragraph_latest_update_item_field_image_item_parser(f[0]) : null

export const paragraph_latest_update_item_parser = (t: ParagraphLatestUpdateItem): ParsedParagraphLatestUpdateItem => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "latest_update_item" => "latest_update_item")(t.type),
  field_image: singular_optional_entity_reference_media_with_target_paragraph_latest_update_item_field_image_parser(t.field_image),
  field_label: singular_required_string_parser(t.field_label),
  field_link: singular_required_link_parser(t.field_link)
})

export const paragraph_latest_update_item_guard = (t: Paragraph): t is ParagraphLatestUpdateItem => paragraph_bundle_parser(t.type) == "latest_update_item"

export const entity_reference_revisions_paragraph_with_target_paragraph_latest_updates_block_field_latest_update_item_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphLatestUpdatesBlockFieldLatestUpdateItemItem): ParsedParagraphLatestUpdateItem | undefined | undefined => (t.target !== undefined ? ((t: ParagraphLatestUpdateItem): ParsedParagraphLatestUpdateItem =>
    paragraph_latest_update_item_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_latest_updates_block_field_latest_update_item_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphLatestUpdatesBlockFieldLatestUpdateItemItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_latest_updates_block_field_latest_update_item_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphLatestUpdatesBlockFieldLatestUpdateItemItem>): List<ParsedParagraphLatestUpdateItem> =>
    List<ParsedParagraphLatestUpdateItem>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_latest_updates_block_field_latest_update_item_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_latest_updates_block_field_latest_update_item_item_parser(i)).filter(i => i !== undefined))

export const paragraph_latest_updates_block_parser = (t: ParagraphLatestUpdatesBlock): ParsedParagraphLatestUpdatesBlock => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "latest_updates_block" => "latest_updates_block")(t.type),
  field_latest_update_item: plural_entity_reference_revisions_paragraph_with_target_paragraph_latest_updates_block_field_latest_update_item_parser(t.field_latest_update_item),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_latest_updates_block_guard = (t: Paragraph): t is ParagraphLatestUpdatesBlock => paragraph_bundle_parser(t.type) == "latest_updates_block"

export const paragraph_link_list_item_parser = (t: ParagraphLinkListItem): ParsedParagraphLinkListItem => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "link_list_item" => "link_list_item")(t.type),
  field_url: singular_required_link_parser(t.field_url)
})

export const paragraph_link_list_item_guard = (t: Paragraph): t is ParagraphLinkListItem => paragraph_bundle_parser(t.type) == "link_list_item"

export const entity_reference_revisions_paragraph_with_target_paragraph_links_list_field_links_list_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphLinksListFieldLinksListItem): ParsedParagraphLinkListItem | undefined | undefined => (t.target !== undefined ? ((t: ParagraphLinkListItem): ParsedParagraphLinkListItem =>
    paragraph_link_list_item_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_links_list_field_links_list_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphLinksListFieldLinksListItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_links_list_field_links_list_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphLinksListFieldLinksListItem>): List<ParsedParagraphLinkListItem> =>
    List<ParsedParagraphLinkListItem>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_links_list_field_links_list_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_links_list_field_links_list_item_parser(i)).filter(i => i !== undefined))

export const paragraph_links_list_parser = (t: ParagraphLinksList): ParsedParagraphLinksList => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "links_list" => "links_list")(t.type),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_links_list: plural_entity_reference_revisions_paragraph_with_target_paragraph_links_list_field_links_list_parser(t.field_links_list),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_links_list_guard = (t: Paragraph): t is ParagraphLinksList => paragraph_bundle_parser(t.type) == "links_list"

export const entity_reference_media_with_target_paragraph_media_field_media_item_parser = (t: EntityReferenceMediaWithTargetParagraphMediaFieldMediaItem): ParsedMediaImage | ParsedMediaVideo | undefined | undefined => (t.target !== undefined ? ((t: MediaImage | MediaVideo): ParsedMediaImage | ParsedMediaVideo =>
  media_image_guard(t) ?
    media_image_parser(t) :
    media_video_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_media_field_media_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphMediaFieldMediaItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph_media_field_media_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphMediaFieldMediaItem>): ParsedMediaImage | ParsedMediaVideo | undefined => entity_reference_media_with_target_paragraph_media_field_media_item_parser(f[0])

export const paragraph_media_parser = (t: ParagraphMedia): ParsedParagraphMedia => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "media" => "media")(t.type),
  field_background: singular_optional_list_string_parser(t.field_background),
  field_caption: singular_optional_string_parser(t.field_caption),
  field_media: singular_required_entity_reference_media_with_target_paragraph_media_field_media_parser(t.field_media)
})

export const paragraph_media_guard = (t: Paragraph): t is ParagraphMedia => paragraph_bundle_parser(t.type) == "media"

export const entity_reference_media_with_target_paragraph_media_item_field_media_item_parser = (t: EntityReferenceMediaWithTargetParagraphMediaItemFieldMediaItem): ParsedMediaImage | ParsedMediaVideo | undefined | undefined => (t.target !== undefined ? ((t: MediaImage | MediaVideo): ParsedMediaImage | ParsedMediaVideo =>
  media_image_guard(t) ?
    media_image_parser(t) :
    media_video_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_media_item_field_media_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphMediaItemFieldMediaItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph_media_item_field_media_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphMediaItemFieldMediaItem>): ParsedMediaImage | ParsedMediaVideo | undefined => entity_reference_media_with_target_paragraph_media_item_field_media_item_parser(f[0])

export const paragraph_media_item_parser = (t: ParagraphMediaItem): ParsedParagraphMediaItem => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "media_item" => "media_item")(t.type),
  field_image_caption: singular_optional_string_long_parser(t.field_image_caption),
  field_image_option: singular_optional_list_string_parser(t.field_image_option),
  field_media: singular_required_entity_reference_media_with_target_paragraph_media_item_field_media_parser(t.field_media)
})

export const paragraph_media_item_guard = (t: Paragraph): t is ParagraphMediaItem => paragraph_bundle_parser(t.type) == "media_item"

export const entity_reference_media_with_target_paragraph_media_item_nested_field_media_item_parser = (t: EntityReferenceMediaWithTargetParagraphMediaItemNestedFieldMediaItem): ParsedMediaImage | ParsedMediaVideo | undefined | undefined => (t.target !== undefined ? ((t: MediaImage | MediaVideo): ParsedMediaImage | ParsedMediaVideo =>
  media_image_guard(t) ?
    media_image_parser(t) :
    media_video_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_media_item_nested_field_media_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphMediaItemNestedFieldMediaItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph_media_item_nested_field_media_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphMediaItemNestedFieldMediaItem>): ParsedMediaImage | ParsedMediaVideo | undefined => entity_reference_media_with_target_paragraph_media_item_nested_field_media_item_parser(f[0])

export const paragraph_media_item_nested_parser = (t: ParagraphMediaItemNested): ParsedParagraphMediaItemNested => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "media_item_nested" => "media_item_nested")(t.type),
  field_image_caption: singular_optional_string_long_parser(t.field_image_caption),
  field_media: singular_required_entity_reference_media_with_target_paragraph_media_item_nested_field_media_parser(t.field_media)
})

export const paragraph_media_item_nested_guard = (t: Paragraph): t is ParagraphMediaItemNested => paragraph_bundle_parser(t.type) == "media_item_nested"

export const entity_reference_revisions_paragraph_with_target_paragraph_media_nested_field_media_item_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphMediaNestedFieldMediaItemItem): ParsedParagraphMediaItemNested | undefined | undefined => (t.target !== undefined ? ((t: ParagraphMediaItemNested): ParsedParagraphMediaItemNested =>
    paragraph_media_item_nested_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_media_nested_field_media_item_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphMediaNestedFieldMediaItemItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_media_nested_field_media_item_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphMediaNestedFieldMediaItemItem>): List<ParsedParagraphMediaItemNested> =>
    List<ParsedParagraphMediaItemNested>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_media_nested_field_media_item_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_media_nested_field_media_item_item_parser(i)).filter(i => i !== undefined))

export const paragraph_media_nested_parser = (t: ParagraphMediaNested): ParsedParagraphMediaNested => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "media_nested" => "media_nested")(t.type),
  field_media_item: plural_entity_reference_revisions_paragraph_with_target_paragraph_media_nested_field_media_item_parser(t.field_media_item)
})

export const paragraph_media_nested_guard = (t: Paragraph): t is ParagraphMediaNested => paragraph_bundle_parser(t.type) == "media_nested"

export const paragraph_press_releases_parser = (t: ParagraphPressReleases): ParsedParagraphPressReleases => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "press_releases" => "press_releases")(t.type),
  field_button: singular_optional_link_parser(t.field_button),
  field_item_limit: singular_optional_integer_parser(t.field_item_limit),
  field_show_year_filter: singular_optional_boolean_parser(t.field_show_year_filter)
})

export const paragraph_press_releases_guard = (t: Paragraph): t is ParagraphPressReleases => paragraph_bundle_parser(t.type) == "press_releases"

export const paragraph_quote_parser = (t: ParagraphQuote): ParsedParagraphQuote => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "quote" => "quote")(t.type),
  field_author_name: singular_required_string_parser(t.field_author_name),
  field_background: singular_optional_list_string_parser(t.field_background),
  field_function: singular_required_string_parser(t.field_function),
  field_links: plural_link_parser(t.field_links),
  field_quote: singular_required_string_parser(t.field_quote)
})

export const paragraph_quote_guard = (t: Paragraph): t is ParagraphQuote => paragraph_bundle_parser(t.type) == "quote"

export const entity_reference_media_with_target_paragraph_quote_item_field_image_item_parser = (t: EntityReferenceMediaWithTargetParagraphQuoteItemFieldImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_quote_item_field_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphQuoteItemFieldImageItem => (t.target_id !== undefined)

export const singular_optional_entity_reference_media_with_target_paragraph_quote_item_field_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphQuoteItemFieldImageItem>): ParsedMediaImage | undefined | null => f && f.length > 0 && entity_reference_media_with_target_paragraph_quote_item_field_image_item_guard(f[0]) ? entity_reference_media_with_target_paragraph_quote_item_field_image_item_parser(f[0]) : null

export const paragraph_quote_item_parser = (t: ParagraphQuoteItem): ParsedParagraphQuoteItem => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "quote_item" => "quote_item")(t.type),
  field_author_name: singular_required_string_parser(t.field_author_name),
  field_function: singular_required_string_parser(t.field_function),
  field_image: singular_optional_entity_reference_media_with_target_paragraph_quote_item_field_image_parser(t.field_image),
  field_link: singular_optional_link_parser(t.field_link),
  field_quote: singular_required_string_parser(t.field_quote)
})

export const paragraph_quote_item_guard = (t: Paragraph): t is ParagraphQuoteItem => paragraph_bundle_parser(t.type) == "quote_item"

export const paragraph_quote_nested_parser = (t: ParagraphQuoteNested): ParsedParagraphQuoteNested => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "quote_nested" => "quote_nested")(t.type),
  field_author_name: singular_optional_string_parser(t.field_author_name),
  field_text: singular_required_string_long_parser(t.field_text)
})

export const paragraph_quote_nested_guard = (t: Paragraph): t is ParagraphQuoteNested => paragraph_bundle_parser(t.type) == "quote_nested"

export const entity_reference_revisions_paragraph_with_target_paragraph_quotes_field_quote_items_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphQuotesFieldQuoteItemsItem): ParsedParagraphQuoteItem | undefined | undefined => (t.target !== undefined ? ((t: ParagraphQuoteItem): ParsedParagraphQuoteItem =>
    paragraph_quote_item_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_quotes_field_quote_items_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphQuotesFieldQuoteItemsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_quotes_field_quote_items_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphQuotesFieldQuoteItemsItem>): List<ParsedParagraphQuoteItem> =>
    List<ParsedParagraphQuoteItem>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_quotes_field_quote_items_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_quotes_field_quote_items_item_parser(i)).filter(i => i !== undefined))

export const paragraph_quotes_parser = (t: ParagraphQuotes): ParsedParagraphQuotes => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "quotes" => "quotes")(t.type),
  field_quote_items: plural_entity_reference_revisions_paragraph_with_target_paragraph_quotes_field_quote_items_parser(t.field_quote_items),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_quotes_guard = (t: Paragraph): t is ParagraphQuotes => paragraph_bundle_parser(t.type) == "quotes"

export const entity_reference_revisions_paragraph_with_target_paragraph_reports_overview_field_tabs_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphReportsOverviewFieldTabsItem): ParsedParagraphReportsTab | undefined | undefined => (t.target !== undefined ? ((t: ParagraphReportsTab): ParsedParagraphReportsTab =>
    paragraph_reports_tab_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_reports_overview_field_tabs_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphReportsOverviewFieldTabsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_reports_overview_field_tabs_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphReportsOverviewFieldTabsItem>): List<ParsedParagraphReportsTab> =>
    List<ParsedParagraphReportsTab>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_reports_overview_field_tabs_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_reports_overview_field_tabs_item_parser(i)).filter(i => i !== undefined))

export const paragraph_reports_overview_parser = (t: ParagraphReportsOverview): ParsedParagraphReportsOverview => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "reports_overview" => "reports_overview")(t.type),
  field_tabs: plural_entity_reference_revisions_paragraph_with_target_paragraph_reports_overview_field_tabs_parser(t.field_tabs)
})

export const paragraph_reports_overview_guard = (t: Paragraph): t is ParagraphReportsOverview => paragraph_bundle_parser(t.type) == "reports_overview"

export const entity_reference_revisions_paragraph_with_target_paragraph_reports_tab_field_rows_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphReportsTabFieldRowsItem): ParsedParagraphReportsTableRow | undefined | undefined => (t.target !== undefined ? ((t: ParagraphReportsTableRow): ParsedParagraphReportsTableRow =>
    paragraph_reports_table_row_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_reports_tab_field_rows_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphReportsTabFieldRowsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_reports_tab_field_rows_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphReportsTabFieldRowsItem>): List<ParsedParagraphReportsTableRow> =>
    List<ParsedParagraphReportsTableRow>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_reports_tab_field_rows_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_reports_tab_field_rows_item_parser(i)).filter(i => i !== undefined))

export const paragraph_reports_tab_parser = (t: ParagraphReportsTab): ParsedParagraphReportsTab => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "reports_tab" => "reports_tab")(t.type),
  field_rows: plural_entity_reference_revisions_paragraph_with_target_paragraph_reports_tab_field_rows_parser(t.field_rows),
  field_title: singular_required_string_parser(t.field_title)
})

export const paragraph_reports_tab_guard = (t: Paragraph): t is ParagraphReportsTab => paragraph_bundle_parser(t.type) == "reports_tab"

export const entity_reference_media_with_target_paragraph_reports_table_row_field_calendar_file_item_parser = (t: EntityReferenceMediaWithTargetParagraphReportsTableRowFieldCalendarFileItem): ParsedMediaDocument | undefined | undefined => (t.target !== undefined ? ((t: MediaDocument): ParsedMediaDocument =>
    media_document_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_reports_table_row_field_calendar_file_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphReportsTableRowFieldCalendarFileItem => (t.target_id !== undefined)

export const singular_optional_entity_reference_media_with_target_paragraph_reports_table_row_field_calendar_file_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphReportsTableRowFieldCalendarFileItem>): ParsedMediaDocument | undefined | null => f && f.length > 0 && entity_reference_media_with_target_paragraph_reports_table_row_field_calendar_file_item_guard(f[0]) ? entity_reference_media_with_target_paragraph_reports_table_row_field_calendar_file_item_parser(f[0]) : null

export const datetime_item_parser = (t: DatetimeItem): Moment.Moment => required_date_time_parser(t.value)

export const singular_required_datetime_parser = (f: FieldItemList<DatetimeItem>): Moment.Moment => datetime_item_parser(f[0])

export const entity_reference_media_with_target_paragraph_reports_table_row_field_presentation_file_item_parser = (t: EntityReferenceMediaWithTargetParagraphReportsTableRowFieldPresentationFileItem): ParsedMediaDocument | undefined | undefined => (t.target !== undefined ? ((t: MediaDocument): ParsedMediaDocument =>
    media_document_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_reports_table_row_field_presentation_file_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphReportsTableRowFieldPresentationFileItem => (t.target_id !== undefined)

export const singular_optional_entity_reference_media_with_target_paragraph_reports_table_row_field_presentation_file_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphReportsTableRowFieldPresentationFileItem>): ParsedMediaDocument | undefined | null => f && f.length > 0 && entity_reference_media_with_target_paragraph_reports_table_row_field_presentation_file_item_guard(f[0]) ? entity_reference_media_with_target_paragraph_reports_table_row_field_presentation_file_item_parser(f[0]) : null

export const entity_reference_media_with_target_paragraph_reports_table_row_field_report_file_item_parser = (t: EntityReferenceMediaWithTargetParagraphReportsTableRowFieldReportFileItem): ParsedMediaDocument | undefined | undefined => (t.target !== undefined ? ((t: MediaDocument): ParsedMediaDocument =>
    media_document_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_reports_table_row_field_report_file_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphReportsTableRowFieldReportFileItem => (t.target_id !== undefined)

export const singular_optional_entity_reference_media_with_target_paragraph_reports_table_row_field_report_file_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphReportsTableRowFieldReportFileItem>): ParsedMediaDocument | undefined | null => f && f.length > 0 && entity_reference_media_with_target_paragraph_reports_table_row_field_report_file_item_guard(f[0]) ? entity_reference_media_with_target_paragraph_reports_table_row_field_report_file_item_parser(f[0]) : null

export const paragraph_reports_table_row_parser = (t: ParagraphReportsTableRow): ParsedParagraphReportsTableRow => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "reports_table_row" => "reports_table_row")(t.type),
  field_body: singular_optional_text_long_parser(t.field_body),
  field_calendar_file: singular_optional_entity_reference_media_with_target_paragraph_reports_table_row_field_calendar_file_parser(t.field_calendar_file),
  field_date: singular_required_datetime_parser(t.field_date),
  field_details: singular_required_string_parser(t.field_details),
  field_presentation_file: singular_optional_entity_reference_media_with_target_paragraph_reports_table_row_field_presentation_file_parser(t.field_presentation_file),
  field_presentation_link: singular_optional_link_parser(t.field_presentation_link),
  field_report_file: singular_optional_entity_reference_media_with_target_paragraph_reports_table_row_field_report_file_parser(t.field_report_file),
  field_report_link: singular_optional_link_parser(t.field_report_link),
  field_webcast: singular_optional_link_parser(t.field_webcast)
})

export const paragraph_reports_table_row_guard = (t: Paragraph): t is ParagraphReportsTableRow => paragraph_bundle_parser(t.type) == "reports_table_row"

export const paragraph_stories_grid_parser = (t: ParagraphStoriesGrid): ParsedParagraphStoriesGrid => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "stories_grid" => "stories_grid")(t.type),
  field_link: singular_optional_link_parser(t.field_link),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_stories_grid_guard = (t: Paragraph): t is ParagraphStoriesGrid => paragraph_bundle_parser(t.type) == "stories_grid"

export const singular_required_text_long_parser = (f: FieldItemList<TextItem>): string => text_item_parser(f[0])

export const paragraph_text_parser = (t: ParagraphText): ParsedParagraphText => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "text" => "text")(t.type),
  field_background: singular_optional_list_string_parser(t.field_background),
  field_body: singular_required_text_long_parser(t.field_body),
  field_links: plural_link_parser(t.field_links),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_text_guard = (t: Paragraph): t is ParagraphText => paragraph_bundle_parser(t.type) == "text"

export const paragraph_text_nested_parser = (t: ParagraphTextNested): ParsedParagraphTextNested => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "text_nested" => "text_nested")(t.type),
  field_body: singular_required_text_long_parser(t.field_body)
})

export const paragraph_text_nested_guard = (t: Paragraph): t is ParagraphTextNested => paragraph_bundle_parser(t.type) == "text_nested"

export const entity_reference_media_with_target_paragraph_text_with_image_field_image_item_parser = (t: EntityReferenceMediaWithTargetParagraphTextWithImageFieldImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_text_with_image_field_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphTextWithImageFieldImageItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_paragraph_text_with_image_field_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphTextWithImageFieldImageItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_paragraph_text_with_image_field_image_item_parser(f[0])

export const paragraph_text_with_image_parser = (t: ParagraphTextWithImage): ParsedParagraphTextWithImage => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "text_with_image" => "text_with_image")(t.type),
  field_body: singular_required_text_long_parser(t.field_body),
  field_featured_content_direction: singular_required_list_string_parser(t.field_featured_content_direction),
  field_image: singular_required_entity_reference_media_with_target_paragraph_text_with_image_field_image_parser(t.field_image),
  field_image_background: singular_optional_list_string_parser(t.field_image_background),
  field_label: singular_optional_string_parser(t.field_label),
  field_links: plural_link_parser(t.field_links),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_text_with_image_guard = (t: Paragraph): t is ParagraphTextWithImage => paragraph_bundle_parser(t.type) == "text_with_image"

export const entity_reference_revisions_paragraph_with_target_paragraph_text_with_read_more_field_read_more_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphTextWithReadMoreFieldReadMoreItem): ParsedParagraphQuoteNested | ParsedParagraphMediaNested | ParsedParagraphTextNested | undefined | undefined => (t.target !== undefined ? ((t: ParagraphQuoteNested | ParagraphMediaNested | ParagraphTextNested): ParsedParagraphQuoteNested | ParsedParagraphMediaNested | ParsedParagraphTextNested =>
  paragraph_quote_nested_guard(t) ?
    paragraph_quote_nested_parser(t) :
  paragraph_media_nested_guard(t) ?
    paragraph_media_nested_parser(t) :
    paragraph_text_nested_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_text_with_read_more_field_read_more_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphTextWithReadMoreFieldReadMoreItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_text_with_read_more_field_read_more_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphTextWithReadMoreFieldReadMoreItem>): List<ParsedParagraphQuoteNested | ParsedParagraphMediaNested | ParsedParagraphTextNested> =>
    List<ParsedParagraphQuoteNested | ParsedParagraphMediaNested | ParsedParagraphTextNested>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_text_with_read_more_field_read_more_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_text_with_read_more_field_read_more_item_parser(i)).filter(i => i !== undefined))

export const paragraph_text_with_read_more_parser = (t: ParagraphTextWithReadMore): ParsedParagraphTextWithReadMore => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "text_with_read_more" => "text_with_read_more")(t.type),
  field_body: singular_required_text_long_parser(t.field_body),
  field_read_more: plural_entity_reference_revisions_paragraph_with_target_paragraph_text_with_read_more_field_read_more_parser(t.field_read_more),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_text_with_read_more_guard = (t: Paragraph): t is ParagraphTextWithReadMore => paragraph_bundle_parser(t.type) == "text_with_read_more"

export const entity_reference_revisions_paragraph_with_target_paragraph_timeline_field_items_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetParagraphTimelineFieldItemsItem): ParsedParagraphTimelineItem | undefined | undefined => (t.target !== undefined ? ((t: ParagraphTimelineItem): ParsedParagraphTimelineItem =>
    paragraph_timeline_item_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_paragraph_timeline_field_items_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetParagraphTimelineFieldItemsItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_paragraph_timeline_field_items_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetParagraphTimelineFieldItemsItem>): List<ParsedParagraphTimelineItem> =>
    List<ParsedParagraphTimelineItem>(f.filter(i => entity_reference_revisions_paragraph_with_target_paragraph_timeline_field_items_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_paragraph_timeline_field_items_item_parser(i)).filter(i => i !== undefined))

export const paragraph_timeline_parser = (t: ParagraphTimeline): ParsedParagraphTimeline => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "timeline" => "timeline")(t.type),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_items: plural_entity_reference_revisions_paragraph_with_target_paragraph_timeline_field_items_parser(t.field_items),
  field_title: singular_optional_string_parser(t.field_title)
})

export const paragraph_timeline_guard = (t: Paragraph): t is ParagraphTimeline => paragraph_bundle_parser(t.type) == "timeline"

export const entity_reference_media_with_target_paragraph_timeline_item_field_media_item_parser = (t: EntityReferenceMediaWithTargetParagraphTimelineItemFieldMediaItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_timeline_item_field_media_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphTimelineItemFieldMediaItem => (t.target_id !== undefined)

export const singular_optional_entity_reference_media_with_target_paragraph_timeline_item_field_media_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphTimelineItemFieldMediaItem>): ParsedMediaImage | undefined | null => f && f.length > 0 && entity_reference_media_with_target_paragraph_timeline_item_field_media_item_guard(f[0]) ? entity_reference_media_with_target_paragraph_timeline_item_field_media_item_parser(f[0]) : null

export const entity_reference_media_with_target_paragraph_timeline_item_field_timeline_background_image_item_parser = (t: EntityReferenceMediaWithTargetParagraphTimelineItemFieldTimelineBackgroundImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_paragraph_timeline_item_field_timeline_background_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetParagraphTimelineItemFieldTimelineBackgroundImageItem => (t.target_id !== undefined)

export const singular_optional_entity_reference_media_with_target_paragraph_timeline_item_field_timeline_background_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetParagraphTimelineItemFieldTimelineBackgroundImageItem>): ParsedMediaImage | undefined | null => f && f.length > 0 && entity_reference_media_with_target_paragraph_timeline_item_field_timeline_background_image_item_guard(f[0]) ? entity_reference_media_with_target_paragraph_timeline_item_field_timeline_background_image_item_parser(f[0]) : null

export const paragraph_timeline_item_parser = (t: ParagraphTimelineItem): ParsedParagraphTimelineItem => ({
  ...paragraph_base_parser(t),
  bundle: ((_: any): "timeline_item" => "timeline_item")(t.type),
  field_introduction: singular_required_string_long_parser(t.field_introduction),
  field_media: singular_optional_entity_reference_media_with_target_paragraph_timeline_item_field_media_parser(t.field_media),
  field_timeline_background_image: singular_optional_entity_reference_media_with_target_paragraph_timeline_item_field_timeline_background_image_parser(t.field_timeline_background_image),
  field_title: singular_required_string_parser(t.field_title)
})

export const paragraph_timeline_item_guard = (t: Paragraph): t is ParagraphTimelineItem => paragraph_bundle_parser(t.type) == "timeline_item"

export const paragraph_parser = (t: Paragraph): ParsedParagraph =>
  paragraph_cta_guard(t) ?
    paragraph_cta_parser(t) :
  paragraph_custom_spacer_guard(t) ?
    paragraph_custom_spacer_parser(t) :
  paragraph_download_list_guard(t) ?
    paragraph_download_list_parser(t) :
  paragraph_downloads_guard(t) ?
    paragraph_downloads_parser(t) :
  paragraph_expandable_content_block_guard(t) ?
    paragraph_expandable_content_block_parser(t) :
  paragraph_expandable_content_blocks_guard(t) ?
    paragraph_expandable_content_blocks_parser(t) :
  paragraph_facts_and_figures_guard(t) ?
    paragraph_facts_and_figures_parser(t) :
  paragraph_facts_and_figures_item_guard(t) ?
    paragraph_facts_and_figures_item_parser(t) :
  paragraph_featured_content_guard(t) ?
    paragraph_featured_content_parser(t) :
  paragraph_form_guard(t) ?
    paragraph_form_parser(t) :
  paragraph_grid_block_image_guard(t) ?
    paragraph_grid_block_image_parser(t) :
  paragraph_grid_block_plain_guard(t) ?
    paragraph_grid_block_plain_parser(t) :
  paragraph_grid_blocks_image_guard(t) ?
    paragraph_grid_blocks_image_parser(t) :
  paragraph_grid_blocks_plain_guard(t) ?
    paragraph_grid_blocks_plain_parser(t) :
  paragraph_grid_highlight_guard(t) ?
    paragraph_grid_highlight_parser(t) :
  paragraph_grid_item_highlight_guard(t) ?
    paragraph_grid_item_highlight_parser(t) :
  paragraph_hubspot_form_guard(t) ?
    paragraph_hubspot_form_parser(t) :
  paragraph_iframe_guard(t) ?
    paragraph_iframe_parser(t) :
  paragraph_image_guard(t) ?
    paragraph_image_parser(t) :
  paragraph_image_gallery_guard(t) ?
    paragraph_image_gallery_parser(t) :
  paragraph_latest_update_item_guard(t) ?
    paragraph_latest_update_item_parser(t) :
  paragraph_latest_updates_block_guard(t) ?
    paragraph_latest_updates_block_parser(t) :
  paragraph_link_list_item_guard(t) ?
    paragraph_link_list_item_parser(t) :
  paragraph_links_list_guard(t) ?
    paragraph_links_list_parser(t) :
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_media_item_guard(t) ?
    paragraph_media_item_parser(t) :
  paragraph_media_item_nested_guard(t) ?
    paragraph_media_item_nested_parser(t) :
  paragraph_media_nested_guard(t) ?
    paragraph_media_nested_parser(t) :
  paragraph_press_releases_guard(t) ?
    paragraph_press_releases_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_quote_item_guard(t) ?
    paragraph_quote_item_parser(t) :
  paragraph_quote_nested_guard(t) ?
    paragraph_quote_nested_parser(t) :
  paragraph_quotes_guard(t) ?
    paragraph_quotes_parser(t) :
  paragraph_reports_overview_guard(t) ?
    paragraph_reports_overview_parser(t) :
  paragraph_reports_tab_guard(t) ?
    paragraph_reports_tab_parser(t) :
  paragraph_reports_table_row_guard(t) ?
    paragraph_reports_table_row_parser(t) :
  paragraph_stories_grid_guard(t) ?
    paragraph_stories_grid_parser(t) :
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_text_nested_guard(t) ?
    paragraph_text_nested_parser(t) :
  paragraph_text_with_image_guard(t) ?
    paragraph_text_with_image_parser(t) :
  paragraph_text_with_read_more_guard(t) ?
    paragraph_text_with_read_more_parser(t) :
  paragraph_timeline_guard(t) ?
    paragraph_timeline_parser(t) :
    paragraph_timeline_item_parser(t)

export const paragraph_guard = (t: Entity): t is Paragraph => (
  (t as any).id !== undefined &&
  (t as any).uuid !== undefined &&
  (t as any).revision_id !== undefined &&
  (t as any).langcode !== undefined &&
  (t as any).type !== undefined &&
  (t as any).type[0].target_type == "paragraphs_type" &&
  (t as any).status !== undefined &&
  (t as any).created !== undefined &&
  (t as any).parent_id !== undefined &&
  (t as any).parent_type !== undefined &&
  (t as any).parent_field_name !== undefined &&
  (t as any).behavior_settings !== undefined &&
  (t as any).default_langcode !== undefined &&
  (t as any).revision_translation_affected !== undefined
)

export const entity_reference_revisions_paragraph_with_target_node_homepage_field_page_content_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeHomepageFieldPageContentItem): ParsedParagraphCta | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphImageGallery | ParsedParagraphIframe | ParsedParagraphLinksList | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphStoriesGrid | ParsedParagraphText | ParsedParagraphTextWithImage | ParsedParagraphPressReleases | ParsedParagraphCustomSpacer | ParsedParagraphQuotes | ParsedParagraphFactsAndFigures | ParsedParagraphLatestUpdatesBlock | undefined | undefined => (t.target !== undefined ? ((t: ParagraphCta | ParagraphDownloads | ParagraphExpandableContentBlocks | ParagraphForm | ParagraphGridBlocksPlain | ParagraphGridBlocksImage | ParagraphImageGallery | ParagraphIframe | ParagraphLinksList | ParagraphMedia | ParagraphQuote | ParagraphStoriesGrid | ParagraphText | ParagraphTextWithImage | ParagraphPressReleases | ParagraphCustomSpacer | ParagraphQuotes | ParagraphFactsAndFigures | ParagraphLatestUpdatesBlock): ParsedParagraphCta | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphImageGallery | ParsedParagraphIframe | ParsedParagraphLinksList | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphStoriesGrid | ParsedParagraphText | ParsedParagraphTextWithImage | ParsedParagraphPressReleases | ParsedParagraphCustomSpacer | ParsedParagraphQuotes | ParsedParagraphFactsAndFigures | ParsedParagraphLatestUpdatesBlock =>
  paragraph_cta_guard(t) ?
    paragraph_cta_parser(t) :
  paragraph_downloads_guard(t) ?
    paragraph_downloads_parser(t) :
  paragraph_expandable_content_blocks_guard(t) ?
    paragraph_expandable_content_blocks_parser(t) :
  paragraph_form_guard(t) ?
    paragraph_form_parser(t) :
  paragraph_grid_blocks_plain_guard(t) ?
    paragraph_grid_blocks_plain_parser(t) :
  paragraph_grid_blocks_image_guard(t) ?
    paragraph_grid_blocks_image_parser(t) :
  paragraph_image_gallery_guard(t) ?
    paragraph_image_gallery_parser(t) :
  paragraph_iframe_guard(t) ?
    paragraph_iframe_parser(t) :
  paragraph_links_list_guard(t) ?
    paragraph_links_list_parser(t) :
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_stories_grid_guard(t) ?
    paragraph_stories_grid_parser(t) :
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_text_with_image_guard(t) ?
    paragraph_text_with_image_parser(t) :
  paragraph_press_releases_guard(t) ?
    paragraph_press_releases_parser(t) :
  paragraph_custom_spacer_guard(t) ?
    paragraph_custom_spacer_parser(t) :
  paragraph_quotes_guard(t) ?
    paragraph_quotes_parser(t) :
  paragraph_facts_and_figures_guard(t) ?
    paragraph_facts_and_figures_parser(t) :
    paragraph_latest_updates_block_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_homepage_field_page_content_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeHomepageFieldPageContentItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_homepage_field_page_content_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeHomepageFieldPageContentItem>): List<ParsedParagraphCta | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphImageGallery | ParsedParagraphIframe | ParsedParagraphLinksList | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphStoriesGrid | ParsedParagraphText | ParsedParagraphTextWithImage | ParsedParagraphPressReleases | ParsedParagraphCustomSpacer | ParsedParagraphQuotes | ParsedParagraphFactsAndFigures | ParsedParagraphLatestUpdatesBlock> =>
    List<ParsedParagraphCta | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphImageGallery | ParsedParagraphIframe | ParsedParagraphLinksList | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphStoriesGrid | ParsedParagraphText | ParsedParagraphTextWithImage | ParsedParagraphPressReleases | ParsedParagraphCustomSpacer | ParsedParagraphQuotes | ParsedParagraphFactsAndFigures | ParsedParagraphLatestUpdatesBlock>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_homepage_field_page_content_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_homepage_field_page_content_item_parser(i)).filter(i => i !== undefined))

export const json_native_binary_item_parser = (t: JsonNativeBinaryItem): string | null => noop_parser<string | null>(t.value)

export const plural_json_native_binary_parser =
  (f: FieldItemList<JsonNativeBinaryItem>): List<string | null> =>
    List<string | null>(f.map(i => json_native_binary_item_parser(i)))

export const node_homepage_parser = (t: NodeHomepage): ParsedNodeHomepage => ({
  ...node_base_parser(t),
  bundle: ((_: any): "homepage" => "homepage")(t.type),
  field_button: singular_optional_link_parser(t.field_button),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_introduction_image: singular_required_entity_reference_media_with_target_node_homepage_field_introduction_image_parser(t.field_introduction_image),
  field_list_image: singular_required_list_string_parser(t.field_list_image),
  field_media: singular_optional_video_embed_field_parser(t.field_media),
  field_metatags: singular_optional_metatag_parser(t.field_metatags),
  field_page_content: plural_entity_reference_revisions_paragraph_with_target_node_homepage_field_page_content_parser(t.field_page_content),
  field_schema_markup: plural_json_native_binary_parser(t.field_schema_markup),
  field_video_close_text: singular_optional_string_parser(t.field_video_close_text),
  field_video_play_text: singular_optional_string_parser(t.field_video_play_text)
})

export const node_homepage_guard = (t: Node): t is NodeHomepage => node_bundle_parser(t.type) == "homepage"

export const entity_reference_media_with_target_node_landing_page_field_introduction_image_item_parser = (t: EntityReferenceMediaWithTargetNodeLandingPageFieldIntroductionImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_landing_page_field_introduction_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeLandingPageFieldIntroductionImageItem => (t.target_id !== undefined)

export const singular_required_entity_reference_media_with_target_node_landing_page_field_introduction_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeLandingPageFieldIntroductionImageItem>): ParsedMediaImage | undefined => entity_reference_media_with_target_node_landing_page_field_introduction_image_item_parser(f[0])

export const entity_reference_revisions_paragraph_with_target_node_landing_page_field_page_content_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeLandingPageFieldPageContentItem): ParsedParagraphText | ParsedParagraphCta | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridHighlight | ParsedParagraphIframe | ParsedParagraphImageGallery | ParsedParagraphLinksList | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphTextWithImage | ParsedParagraphTimeline | ParsedParagraphGridBlocksImage | ParsedParagraphCustomSpacer | ParsedParagraphQuotes | ParsedParagraphFactsAndFigures | ParsedParagraphLatestUpdatesBlock | undefined | undefined => (t.target !== undefined ? ((t: ParagraphText | ParagraphCta | ParagraphDownloads | ParagraphExpandableContentBlocks | ParagraphForm | ParagraphGridBlocksPlain | ParagraphGridHighlight | ParagraphIframe | ParagraphImageGallery | ParagraphLinksList | ParagraphMedia | ParagraphQuote | ParagraphTextWithImage | ParagraphTimeline | ParagraphGridBlocksImage | ParagraphCustomSpacer | ParagraphQuotes | ParagraphFactsAndFigures | ParagraphLatestUpdatesBlock): ParsedParagraphText | ParsedParagraphCta | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridHighlight | ParsedParagraphIframe | ParsedParagraphImageGallery | ParsedParagraphLinksList | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphTextWithImage | ParsedParagraphTimeline | ParsedParagraphGridBlocksImage | ParsedParagraphCustomSpacer | ParsedParagraphQuotes | ParsedParagraphFactsAndFigures | ParsedParagraphLatestUpdatesBlock =>
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_cta_guard(t) ?
    paragraph_cta_parser(t) :
  paragraph_downloads_guard(t) ?
    paragraph_downloads_parser(t) :
  paragraph_expandable_content_blocks_guard(t) ?
    paragraph_expandable_content_blocks_parser(t) :
  paragraph_form_guard(t) ?
    paragraph_form_parser(t) :
  paragraph_grid_blocks_plain_guard(t) ?
    paragraph_grid_blocks_plain_parser(t) :
  paragraph_grid_highlight_guard(t) ?
    paragraph_grid_highlight_parser(t) :
  paragraph_iframe_guard(t) ?
    paragraph_iframe_parser(t) :
  paragraph_image_gallery_guard(t) ?
    paragraph_image_gallery_parser(t) :
  paragraph_links_list_guard(t) ?
    paragraph_links_list_parser(t) :
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_text_with_image_guard(t) ?
    paragraph_text_with_image_parser(t) :
  paragraph_timeline_guard(t) ?
    paragraph_timeline_parser(t) :
  paragraph_grid_blocks_image_guard(t) ?
    paragraph_grid_blocks_image_parser(t) :
  paragraph_custom_spacer_guard(t) ?
    paragraph_custom_spacer_parser(t) :
  paragraph_quotes_guard(t) ?
    paragraph_quotes_parser(t) :
  paragraph_facts_and_figures_guard(t) ?
    paragraph_facts_and_figures_parser(t) :
    paragraph_latest_updates_block_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_landing_page_field_page_content_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeLandingPageFieldPageContentItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_landing_page_field_page_content_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeLandingPageFieldPageContentItem>): List<ParsedParagraphText | ParsedParagraphCta | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridHighlight | ParsedParagraphIframe | ParsedParagraphImageGallery | ParsedParagraphLinksList | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphTextWithImage | ParsedParagraphTimeline | ParsedParagraphGridBlocksImage | ParsedParagraphCustomSpacer | ParsedParagraphQuotes | ParsedParagraphFactsAndFigures | ParsedParagraphLatestUpdatesBlock> =>
    List<ParsedParagraphText | ParsedParagraphCta | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridHighlight | ParsedParagraphIframe | ParsedParagraphImageGallery | ParsedParagraphLinksList | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphTextWithImage | ParsedParagraphTimeline | ParsedParagraphGridBlocksImage | ParsedParagraphCustomSpacer | ParsedParagraphQuotes | ParsedParagraphFactsAndFigures | ParsedParagraphLatestUpdatesBlock>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_landing_page_field_page_content_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_landing_page_field_page_content_item_parser(i)).filter(i => i !== undefined))

export const node_landing_page_parser = (t: NodeLandingPage): ParsedNodeLandingPage => ({
  ...node_base_parser(t),
  bundle: ((_: any): "landing_page" => "landing_page")(t.type),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_introduction_image: singular_required_entity_reference_media_with_target_node_landing_page_field_introduction_image_parser(t.field_introduction_image),
  field_list_image: singular_required_list_string_parser(t.field_list_image),
  field_metatags: singular_optional_metatag_parser(t.field_metatags),
  field_page_content: plural_entity_reference_revisions_paragraph_with_target_node_landing_page_field_page_content_parser(t.field_page_content),
  field_schema_markup: plural_json_native_binary_parser(t.field_schema_markup)
})

export const node_landing_page_guard = (t: Node): t is NodeLandingPage => node_bundle_parser(t.type) == "landing_page"

export const entity_reference_media_with_target_node_page_field_introduction_image_item_parser = (t: EntityReferenceMediaWithTargetNodePageFieldIntroductionImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_page_field_introduction_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodePageFieldIntroductionImageItem => (t.target_id !== undefined)

export const singular_optional_entity_reference_media_with_target_node_page_field_introduction_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodePageFieldIntroductionImageItem>): ParsedMediaImage | undefined | null => f && f.length > 0 && entity_reference_media_with_target_node_page_field_introduction_image_item_guard(f[0]) ? entity_reference_media_with_target_node_page_field_introduction_image_item_parser(f[0]) : null

export const entity_reference_revisions_paragraph_with_target_node_page_field_page_content_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodePageFieldPageContentItem): ParsedParagraphCta | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphIframe | ParsedParagraphImageGallery | ParsedParagraphLinksList | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphText | ParsedParagraphTextWithImage | ParsedParagraphTimeline | ParsedParagraphPressReleases | ParsedParagraphCustomSpacer | ParsedParagraphQuotes | ParsedParagraphLatestUpdatesBlock | ParsedParagraphReportsOverview | ParsedParagraphFactsAndFigures | undefined | undefined => (t.target !== undefined ? ((t: ParagraphCta | ParagraphDownloads | ParagraphExpandableContentBlocks | ParagraphForm | ParagraphGridBlocksPlain | ParagraphGridBlocksImage | ParagraphIframe | ParagraphImageGallery | ParagraphLinksList | ParagraphMedia | ParagraphQuote | ParagraphText | ParagraphTextWithImage | ParagraphTimeline | ParagraphPressReleases | ParagraphCustomSpacer | ParagraphQuotes | ParagraphLatestUpdatesBlock | ParagraphReportsOverview | ParagraphFactsAndFigures): ParsedParagraphCta | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphIframe | ParsedParagraphImageGallery | ParsedParagraphLinksList | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphText | ParsedParagraphTextWithImage | ParsedParagraphTimeline | ParsedParagraphPressReleases | ParsedParagraphCustomSpacer | ParsedParagraphQuotes | ParsedParagraphLatestUpdatesBlock | ParsedParagraphReportsOverview | ParsedParagraphFactsAndFigures =>
  paragraph_cta_guard(t) ?
    paragraph_cta_parser(t) :
  paragraph_downloads_guard(t) ?
    paragraph_downloads_parser(t) :
  paragraph_expandable_content_blocks_guard(t) ?
    paragraph_expandable_content_blocks_parser(t) :
  paragraph_form_guard(t) ?
    paragraph_form_parser(t) :
  paragraph_grid_blocks_plain_guard(t) ?
    paragraph_grid_blocks_plain_parser(t) :
  paragraph_grid_blocks_image_guard(t) ?
    paragraph_grid_blocks_image_parser(t) :
  paragraph_iframe_guard(t) ?
    paragraph_iframe_parser(t) :
  paragraph_image_gallery_guard(t) ?
    paragraph_image_gallery_parser(t) :
  paragraph_links_list_guard(t) ?
    paragraph_links_list_parser(t) :
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_text_with_image_guard(t) ?
    paragraph_text_with_image_parser(t) :
  paragraph_timeline_guard(t) ?
    paragraph_timeline_parser(t) :
  paragraph_press_releases_guard(t) ?
    paragraph_press_releases_parser(t) :
  paragraph_custom_spacer_guard(t) ?
    paragraph_custom_spacer_parser(t) :
  paragraph_quotes_guard(t) ?
    paragraph_quotes_parser(t) :
  paragraph_latest_updates_block_guard(t) ?
    paragraph_latest_updates_block_parser(t) :
  paragraph_reports_overview_guard(t) ?
    paragraph_reports_overview_parser(t) :
    paragraph_facts_and_figures_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_page_field_page_content_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodePageFieldPageContentItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_page_field_page_content_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodePageFieldPageContentItem>): List<ParsedParagraphCta | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphIframe | ParsedParagraphImageGallery | ParsedParagraphLinksList | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphText | ParsedParagraphTextWithImage | ParsedParagraphTimeline | ParsedParagraphPressReleases | ParsedParagraphCustomSpacer | ParsedParagraphQuotes | ParsedParagraphLatestUpdatesBlock | ParsedParagraphReportsOverview | ParsedParagraphFactsAndFigures> =>
    List<ParsedParagraphCta | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphForm | ParsedParagraphGridBlocksPlain | ParsedParagraphGridBlocksImage | ParsedParagraphIframe | ParsedParagraphImageGallery | ParsedParagraphLinksList | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphText | ParsedParagraphTextWithImage | ParsedParagraphTimeline | ParsedParagraphPressReleases | ParsedParagraphCustomSpacer | ParsedParagraphQuotes | ParsedParagraphLatestUpdatesBlock | ParsedParagraphReportsOverview | ParsedParagraphFactsAndFigures>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_page_field_page_content_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_page_field_page_content_item_parser(i)).filter(i => i !== undefined))

export const node_page_parser = (t: NodePage): ParsedNodePage => ({
  ...node_base_parser(t),
  bundle: ((_: any): "page" => "page")(t.type),
  field_global_parent_page: singular_optional_string_parser(t.field_global_parent_page),
  field_introduction: singular_optional_string_long_parser(t.field_introduction),
  field_introduction_image: singular_optional_entity_reference_media_with_target_node_page_field_introduction_image_parser(t.field_introduction_image),
  field_list_image: singular_required_list_string_parser(t.field_list_image),
  field_metatags: singular_optional_metatag_parser(t.field_metatags),
  field_page_content: plural_entity_reference_revisions_paragraph_with_target_node_page_field_page_content_parser(t.field_page_content),
  field_refresco_branding: singular_optional_boolean_parser(t.field_refresco_branding),
  field_schema_markup: plural_json_native_binary_parser(t.field_schema_markup)
})

export const node_page_guard = (t: Node): t is NodePage => node_bundle_parser(t.type) == "page"

export const entity_reference_media_with_target_node_story_field_introduction_image_item_parser = (t: EntityReferenceMediaWithTargetNodeStoryFieldIntroductionImageItem): ParsedMediaImage | undefined | undefined => (t.target !== undefined ? ((t: MediaImage): ParsedMediaImage =>
    media_image_parser(t))(t.target) : undefined)

export const entity_reference_media_with_target_node_story_field_introduction_image_item_guard = (t: any): t is EntityReferenceMediaWithTargetNodeStoryFieldIntroductionImageItem => (t.target_id !== undefined)

export const singular_optional_entity_reference_media_with_target_node_story_field_introduction_image_parser = (f: FieldItemList<EntityReferenceMediaWithTargetNodeStoryFieldIntroductionImageItem>): ParsedMediaImage | undefined | null => f && f.length > 0 && entity_reference_media_with_target_node_story_field_introduction_image_item_guard(f[0]) ? entity_reference_media_with_target_node_story_field_introduction_image_item_parser(f[0]) : null

export const entity_reference_revisions_paragraph_with_target_node_story_field_page_content_item_parser = (t: EntityReferenceRevisionsParagraphWithTargetNodeStoryFieldPageContentItem): ParsedParagraphCta | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphForm | ParsedParagraphGridBlocksImage | ParsedParagraphGridBlocksPlain | ParsedParagraphImageGallery | ParsedParagraphLinksList | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphText | ParsedParagraphTextWithImage | ParsedParagraphTimeline | ParsedParagraphCustomSpacer | ParsedParagraphQuotes | ParsedParagraphFactsAndFigures | ParsedParagraphLatestUpdatesBlock | undefined | undefined => (t.target !== undefined ? ((t: ParagraphCta | ParagraphDownloads | ParagraphExpandableContentBlocks | ParagraphForm | ParagraphGridBlocksImage | ParagraphGridBlocksPlain | ParagraphImageGallery | ParagraphLinksList | ParagraphMedia | ParagraphQuote | ParagraphText | ParagraphTextWithImage | ParagraphTimeline | ParagraphCustomSpacer | ParagraphQuotes | ParagraphFactsAndFigures | ParagraphLatestUpdatesBlock): ParsedParagraphCta | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphForm | ParsedParagraphGridBlocksImage | ParsedParagraphGridBlocksPlain | ParsedParagraphImageGallery | ParsedParagraphLinksList | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphText | ParsedParagraphTextWithImage | ParsedParagraphTimeline | ParsedParagraphCustomSpacer | ParsedParagraphQuotes | ParsedParagraphFactsAndFigures | ParsedParagraphLatestUpdatesBlock =>
  paragraph_cta_guard(t) ?
    paragraph_cta_parser(t) :
  paragraph_downloads_guard(t) ?
    paragraph_downloads_parser(t) :
  paragraph_expandable_content_blocks_guard(t) ?
    paragraph_expandable_content_blocks_parser(t) :
  paragraph_form_guard(t) ?
    paragraph_form_parser(t) :
  paragraph_grid_blocks_image_guard(t) ?
    paragraph_grid_blocks_image_parser(t) :
  paragraph_grid_blocks_plain_guard(t) ?
    paragraph_grid_blocks_plain_parser(t) :
  paragraph_image_gallery_guard(t) ?
    paragraph_image_gallery_parser(t) :
  paragraph_links_list_guard(t) ?
    paragraph_links_list_parser(t) :
  paragraph_media_guard(t) ?
    paragraph_media_parser(t) :
  paragraph_quote_guard(t) ?
    paragraph_quote_parser(t) :
  paragraph_text_guard(t) ?
    paragraph_text_parser(t) :
  paragraph_text_with_image_guard(t) ?
    paragraph_text_with_image_parser(t) :
  paragraph_timeline_guard(t) ?
    paragraph_timeline_parser(t) :
  paragraph_custom_spacer_guard(t) ?
    paragraph_custom_spacer_parser(t) :
  paragraph_quotes_guard(t) ?
    paragraph_quotes_parser(t) :
  paragraph_facts_and_figures_guard(t) ?
    paragraph_facts_and_figures_parser(t) :
    paragraph_latest_updates_block_parser(t))(t.target) : undefined)

export const entity_reference_revisions_paragraph_with_target_node_story_field_page_content_item_guard = (t: any): t is EntityReferenceRevisionsParagraphWithTargetNodeStoryFieldPageContentItem => (t.target_id !== undefined) && (t.target_revision_id !== undefined)

export const plural_entity_reference_revisions_paragraph_with_target_node_story_field_page_content_parser =
  (f: FieldItemList<EntityReferenceRevisionsParagraphWithTargetNodeStoryFieldPageContentItem>): List<ParsedParagraphCta | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphForm | ParsedParagraphGridBlocksImage | ParsedParagraphGridBlocksPlain | ParsedParagraphImageGallery | ParsedParagraphLinksList | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphText | ParsedParagraphTextWithImage | ParsedParagraphTimeline | ParsedParagraphCustomSpacer | ParsedParagraphQuotes | ParsedParagraphFactsAndFigures | ParsedParagraphLatestUpdatesBlock> =>
    List<ParsedParagraphCta | ParsedParagraphDownloads | ParsedParagraphExpandableContentBlocks | ParsedParagraphForm | ParsedParagraphGridBlocksImage | ParsedParagraphGridBlocksPlain | ParsedParagraphImageGallery | ParsedParagraphLinksList | ParsedParagraphMedia | ParsedParagraphQuote | ParsedParagraphText | ParsedParagraphTextWithImage | ParsedParagraphTimeline | ParsedParagraphCustomSpacer | ParsedParagraphQuotes | ParsedParagraphFactsAndFigures | ParsedParagraphLatestUpdatesBlock>(f.filter(i => entity_reference_revisions_paragraph_with_target_node_story_field_page_content_item_guard(i)).map(i => entity_reference_revisions_paragraph_with_target_node_story_field_page_content_item_parser(i)).filter(i => i !== undefined))

export const node_story_parser = (t: NodeStory): ParsedNodeStory => ({
  ...node_base_parser(t),
  bundle: ((_: any): "story" => "story")(t.type),
  field_global_parent_page: singular_optional_string_parser(t.field_global_parent_page),
  field_introduction_image: singular_optional_entity_reference_media_with_target_node_story_field_introduction_image_parser(t.field_introduction_image),
  field_metatags: singular_optional_metatag_parser(t.field_metatags),
  field_page_content: plural_entity_reference_revisions_paragraph_with_target_node_story_field_page_content_parser(t.field_page_content),
  field_schema_markup: plural_json_native_binary_parser(t.field_schema_markup)
})

export const node_story_guard = (t: Node): t is NodeStory => node_bundle_parser(t.type) == "story"

export const node_parser = (t: Node): ParsedNode =>
  node_homepage_guard(t) ?
    node_homepage_parser(t) :
  node_landing_page_guard(t) ?
    node_landing_page_parser(t) :
  node_page_guard(t) ?
    node_page_parser(t) :
    node_story_parser(t)

export const node_guard = (t: Entity): t is Node => (
  (t as any).nid !== undefined &&
  (t as any).uuid !== undefined &&
  (t as any).vid !== undefined &&
  (t as any).langcode !== undefined &&
  (t as any).type !== undefined &&
  (t as any).type[0].target_type == "node_type" &&
  (t as any).revision_timestamp !== undefined &&
  (t as any).revision_uid !== undefined &&
  (t as any).revision_log !== undefined &&
  (t as any).status !== undefined &&
  (t as any).uid !== undefined &&
  (t as any).title !== undefined &&
  (t as any).created !== undefined &&
  (t as any).changed !== undefined &&
  (t as any).promote !== undefined &&
  (t as any).sticky !== undefined &&
  (t as any).default_langcode !== undefined &&
  (t as any).revision_translation_affected !== undefined &&
  (t as any).moderation_state !== undefined &&
  (t as any).metatag !== undefined &&
  (t as any).content_translation_source !== undefined &&
  (t as any).content_translation_outdated !== undefined
)

export const entity_reference_taxonomy_vocabulary_item_parser = (t: EntityReferenceTaxonomyVocabularyItem): ParsedEntityReferenceTaxonomyVocabularyItem => ({
  target_id: noop_parser<string>(t.target_id),
  label: t.target_label
})

export const singular_required_entity_reference_taxonomy_vocabulary_parser = (f: FieldItemList<EntityReferenceTaxonomyVocabularyItem>): ParsedEntityReferenceTaxonomyVocabularyItem => entity_reference_taxonomy_vocabulary_item_parser(f[0])

export const taxonomy_term_bundle_parser = (f: FieldItemList<EntityReferenceTaxonomyVocabularyItem>): string => f[0].target_id

export const entity_reference_taxonomy_term_with_target_item_parser = (t: EntityReferenceTaxonomyTermWithTargetItem): ParsedTaxonomyTerm | undefined | undefined => (t.target !== undefined ? taxonomy_term_parser(t.target) : undefined)

export const entity_reference_taxonomy_term_with_target_item_guard = (t: any): t is EntityReferenceTaxonomyTermWithTargetItem => (t.target_id !== undefined) && ((t.target === undefined) || taxonomy_term_guard(t.target))

export const plural_entity_reference_taxonomy_term_with_target_parser =
  (f: FieldItemList<EntityReferenceTaxonomyTermWithTargetItem>): List<ParsedTaxonomyTerm> =>
    List<ParsedTaxonomyTerm>(f.filter(i => entity_reference_taxonomy_term_with_target_item_guard(i)).map(i => entity_reference_taxonomy_term_with_target_item_parser(i)).filter(i => i !== undefined))

export const taxonomy_term_base_parser = (t: TaxonomyTermBase): ParsedTaxonomyTermBase => ({
  entity_type: ((_: any): "taxonomy_term" => "taxonomy_term")(t),
  id: singular_optional_integer_parser(t.tid),
  language: singular_optional_language_parser(t.langcode),
  label: singular_required_string_parser(t.name),
  revision_created: singular_optional_created_parser(t.revision_created),
  revision_user: singular_optional_entity_reference_user_parser(t.revision_user),
  revision_log_message: singular_optional_string_long_parser(t.revision_log_message),
  status: singular_optional_boolean_parser(t.status),
  description: singular_optional_text_long_parser(t.description),
  weight: singular_optional_integer_parser(t.weight),
  parent: plural_entity_reference_taxonomy_term_with_target_parser(t.parent),
  changed: singular_optional_changed_parser(t.changed),
  default_langcode: singular_optional_boolean_parser(t.default_langcode),
  revision_translation_affected: singular_optional_boolean_parser(t.revision_translation_affected),
  metatag: metatag_field_parser(t.metatag),
  path: singular_optional_path_parser(t.path),
  language_links: language_links_parser(t.language_links),
  entity_operations: entity_operations_parser(t.entity_operations)
})

export const taxonomy_term_page_type_parser = (t: TaxonomyTermPageType): ParsedTaxonomyTermPageType => ({
  ...taxonomy_term_base_parser(t),
  bundle: ((_: any): "page_type" => "page_type")(t.vid)
})

export const taxonomy_term_page_type_guard = (t: TaxonomyTerm): t is TaxonomyTermPageType => taxonomy_term_bundle_parser(t.vid) == "page_type"

export const taxonomy_term_parser = (t: TaxonomyTerm): ParsedTaxonomyTerm =>
    taxonomy_term_page_type_parser(t)

export const taxonomy_term_guard = (t: Entity): t is TaxonomyTerm => (
  (t as any).tid !== undefined &&
  (t as any).uuid !== undefined &&
  (t as any).revision_id !== undefined &&
  (t as any).langcode !== undefined &&
  (t as any).vid !== undefined &&
  (t as any).vid[0].target_type == "taxonomy_vocabulary" &&
  (t as any).revision_created !== undefined &&
  (t as any).revision_user !== undefined &&
  (t as any).revision_log_message !== undefined &&
  (t as any).status !== undefined &&
  (t as any).name !== undefined &&
  (t as any).description !== undefined &&
  (t as any).weight !== undefined &&
  (t as any).parent !== undefined &&
  (t as any).changed !== undefined &&
  (t as any).default_langcode !== undefined &&
  (t as any).revision_translation_affected !== undefined &&
  (t as any).metatag !== undefined
)

export const input_entity_parser = (t: InputEntity): ParsedInputEntity =>
  node_guard(t) ?
    node_parser(t) :
    taxonomy_term_parser(t)

export const entity_parser = (t: Entity): ParsedEntity =>
  node_guard(t) ?
    node_parser(t) :
  media_guard(t) ?
    media_parser(t) :
  file_guard(t) ?
    file_parser(t) :
  paragraph_guard(t) ?
    paragraph_parser(t) :
    taxonomy_term_parser(t)

export const input_entity_guard = (t: any): t is InputEntity => (
  node_guard(t as InputEntity) ||
  taxonomy_term_guard(t as InputEntity)
)

export const entity_guard = (t: any): t is Entity => (
  node_guard(t as Entity) ||
  media_guard(t as Entity) ||
  file_guard(t as Entity) ||
  paragraph_guard(t as Entity) ||
  taxonomy_term_guard(t as Entity)
)